const serviceListMockedData = [
  {
    "id": 1,
    "organization_id": 969,
    "location_id": 970,
    "source_service_id": 1106,
    "source_id_programAtSite": 80757500,
    "source_id_program": 78143321,
    "source": "icarol",
    "program_id": null,
    "program": "CHILDREN'S ADVOCACY CENTER",
    "name": "COUNSELING SERVICES AND PREVENTION FOR CHILDREN WHO ARE ABUSED",
    "alternate_name": "CHILDREN'S ADVOCACY CENTER",
    "description": "Provides forensic interviews for sexually abused children, counseling services for sexually abused children, including adults survivors of child sexual abuse, and prevention education.",
    "url": "www.swmichigancac.org",
    "email": "info@swmichigancac.org",
    "status": 1,
    "interpretation_services": null,
    "application_process": "Referral required from Child Protective Services or Law Enforcement for forensic interviewing services. Therapy services available to children and adult survivors of child sexual abuse.",
    "wait_time": null,
    "fees": "No fees",
    "accreditations": null,
    "licenses": null,
    "eligibility": "Children and families of suspected child abuse in Southwest Michigan",
    "language": "Interpretation services available",
    "payment_accepted": "Not applicable",
    "required_document": "Referral information",
    "service_area": "Berrien, Cass and Van Buren Counties",
    "area_served_description": "Berrien, Cass and Van Buren Counties",
    "region": "GRYP",
    "address_1": "4938 Niles Road",
    "city": "Saint Joseph",
    "county": "Berrien",
    "postal_code": "49085",
    "organization_name": "CHILDREN'S ADVOCACY CENTER OF SOUTHWEST MICHIGAN xx",
    "location_name": "CHILDREN'S ADVOCACY CENTER OF SOUTHWEST MICHIGAN",
    "distance_miles": 10.2345
  },
  {
    "id": 2,
    "organization_id": 975,
    "location_id": 976,
    "source_service_id": 1111,
    "source_id_programAtSite": null,
    "source_id_program": null,
    "source": "Test Data",
    "program_id": null,
    "program": "Best Apple Smack Talk",
    "name": "You like apples? (sp)",
    "alternate_name": "How you like them apples (sp)",
    "description": "Good will hunting is top 10 all time (sp)",
    "url": "www.freeapples.sp",
    "email": "dem@apples.sp",
    "status": 1,
    "interpretation_services": null,
    "application_process": "Referral in apples (sp)",
    "wait_time": null,
    "fees": "Donation accepted (sp)",
    "accreditations": null,
    "licenses": null,
    "eligibility": "No restrictions (sp)",
    "language": "English, Spanish",
    "payment_accepted": "Not applicable",
    "required_document": "No documentation required",
    "service_area": "Various locations",
    "area_served_description": "Various locations",
    "region": "MICH",
    "address_1": "111 Golf Lane",
    "city": "East Grand Rapids",
    "county": "Kent",
    "postal_code": "49511",
    "organization_name": "TEST Organization Apples",
    "location_name": "TEST Location Apples",
    "distance_miles": 11.2345
  },
  {
    "id": 1692,
    "organization_id": 1384,
    "location_id": 1385,
    "source_service_id": 1542,
    "source_id_programAtSite": null,
    "source_id_program": null,
    "source": "data warehouse",
    "program_id": null,
    "program": "REFERRAL FOR AIDS TESTING",
    "name": "HIV TESTING",
    "alternate_name": null,
    "description": "Refers for testing to Immunology Services (formerly McCauley Clinic) persons who seem 'at risk' for HIV/AIDS.  Will arrange on a person-by-person basis for persons to be tested at Heartside Clinic if that seems the best approach.",
    "url": "www.mercyhealth.com",
    "email": "mercyhealthnews@mercyhealth.com",
    "status": 1,
    "interpretation_services": null,
    "application_process": "Call for more information",
    "wait_time": null,
    "fees": "No fees",
    "accreditations": null,
    "licenses": null,
    "eligibility": "Persons who are HIV positive",
    "language": null,
    "payment_accepted": "Not applicable",
    "required_document": "Call for more information",
    "service_area": "Kent County",
    "area_served_description": "Kent County",
    "region": "HWMI",
    "address_1": "200 Jefferson Avenue SE",
    "city": "Grand Rapids",
    "county": "Kent",
    "postal_code": "49503",
    "organization_name": "MERCY HEALTH SAINT MARY'S",
    "location_name": "MERCY HEALTH SAINT MARY'S",
    "distance_miles": 13.2345
  },
  {
    "id": 3060,
    "organization_id": 3502,
    "location_id": 3503,
    "source_service_id": 4518,
    "source_id_programAtSite": 80770901,
    "source_id_program": 78166592,
    "source": "icarol",
    "program_id": null,
    "program": "HIV PREVENTION PROGRAMS",
    "name": "AIDS/HIV CONTROL AND EDUCATION",
    "alternate_name": null,
    "description": "Provides HIV education presentations, displays at community events, bar and street outreach, workshops (on topics such as condom use, safer sex information, etc.)and support groups for people living with HIV to anyone in West Michigan requesting the service. GRRP also provides the only needle exchange program in West Michigan which provides free HIV and Hepatitis C testing, overdose prevention, comprehensive harm-reduction education, and referrals to substance abuse treatment. Condoms can also be distributed to local businesses. Cultural and age appropriate presentations and literature are available.",
    "url": "www.redproject.org",
    "email": "harold@redproject.org",
    "status": 1,
    "interpretation_services": null,
    "application_process": "Call to discuss needs",
    "wait_time": null,
    "fees": "All services are provided free of charge",
    "accreditations": null,
    "licenses": null,
    "eligibility": "No restrictions",
    "language": null,
    "payment_accepted": "Not applicable",
    "required_document": "None required",
    "service_area": "Kent County",
    "area_served_description": "Kent County",
    "region": "HWMI",
    "address_1": "401 Hall Street SE third",
    "city": "Grand Rapids",
    "county": "Kent",
    "postal_code": "495071845",
    "organization_name": "Organization Name",
    "location_name": "Location Name",
    "distance_miles": 13.2345
  },
  {
    "id": 4036,
    "organization_id": 3502,
    "location_id": 3503,
    "source_service_id": 4516,
    "source_id_programAtSite": null,
    "source_id_program": null,
    "source": "data warehouse",
    "program_id": null,
    "program": "HIV PREVENTION OUTREACH WORKER",
    "name": "HEALTH/DISABILITIES RELATED VOLUNTEER OPPORTUNITY FOR HIV PREVENTION AND TESTING",
    "alternate_name": null,
    "description": "Assists staff in providing HIV/AIDS Risk Education Outreach at Bar Parties, Community Health Fairs, and other scheduled events. Set up table displays for distribution using condoms, dental dams etc. and risk reduction education materials. Distribute literature and answer questions on safer sex practices. Provide education on risk reduction behaviors for HIV/AIDS prevention. Administer and evaluate client mini-surveys to assess the knowledge of risk reduction practices and behavior. Interact with community and answer questions relating to HIV/AIDS and other sexually transmitted diseases. HIV Antibody testing and other health services as requested. Promote GRRP. Interact with staff and volunteers from other agencies.",
    "url": "www.redproject.org",
    "email": "info@redproject.org",
    "status": 1,
    "interpretation_services": null,
    "application_process": "Call to inquire",
    "wait_time": null,
    "fees": "No fees",
    "accreditations": null,
    "licenses": null,
    "eligibility": "Age 18 or older",
    "language": null,
    "payment_accepted": "Not applicable",
    "required_document": "No documentation required",
    "service_area": "Kent County",
    "area_served_description": "Kent County",
    "region": "HWMI",
    "address_1": "401 Hall Street SE third",
    "city": "Grand Rapids",
    "county": "Kent",
    "postal_code": "495071845",
    "organization_name": "Organization Name",
    "location_name": "Location Name",
    "distance_miles": 13.2345,
  },
  {
    "id": 4037,
    "organization_id": 3502,
    "location_id": 3503,
    "source_service_id": 4516,
    "source_id_programAtSite": null,
    "source_id_program": null,
    "source": "data warehouse",
    "program_id": null,
    "program": "Service Program Pear",
    "name": "Service Name Pear",
    "alternate_name": null,
    "description": "Service Description Pear",
    "url": "www.redproject.org",
    "email": "info@redproject.org",
    "status": 1,
    "interpretation_services": null,
    "application_process": "Call to inquire",
    "wait_time": null,
    "fees": "No fees",
    "accreditations": null,
    "licenses": null,
    "eligibility": "Age 18 or older",
    "language": null,
    "payment_accepted": "Not applicable",
    "required_document": "No documentation required",
    "service_area": "Kent County Pear",
    "area_served_description": "Kent County Pear",
    "region": "HWMI",
    "address_1": "401 Hall Street SE third",
    "city": "Grand Rapids",
    "county": "Kent",
    "postal_code": "495071845",
    "organization_name": "Organization Name",
    "location_name": "Location Name",
    "distance_miles": 13.2345
  },
  {
    "id": 8426,
    "organization_id": 6238,
    "location_id": 6239,
    "source_service_id": 7865,
    "source_id_programAtSite": 78227054,
    "source_id_program": 78143353,
    "source": "icarol",
    "program_id": null,
    "program": "SEXUALLY TRANSMITTED INFECTION SCREENING",
    "name": "SCREENING/DIAGNOSIS FOR SEXUALLY TRANSMITTED DISEASE",
    "alternate_name": "SEXUALLY TRANSMITTED INFECTION SCREENING",
    "description": "Provides a Chembio HIV 1/2 Stat Pak, 15 min results with finger poke blood test. Urine base Chlamydia and Gonorrhea screening and treatment if necessary.",
    "url": "www.alternativescc.org",
    "email": "info@alternativesofkzoo.org",
    "status": 1,
    "interpretation_services": null,
    "application_process": "Call for appointment",
    "wait_time": null,
    "fees": "No fees; Donations accepted, not required",
    "accreditations": null,
    "licenses": null,
    "eligibility": "No restrictions",
    "language": null,
    "payment_accepted": "Not applicable",
    "required_document": "Government issued photo identification",
    "service_area": "Serves all areas",
    "area_served_description": "Serves all areas",
    "region": "GRYP",
    "address_1": "4200 West Michigan Avenue",
    "city": "Kalamazoo",
    "county": "Kalamazoo",
    "postal_code": "49006",
    "organization_name": "ALTERNATIVES OF KALAMAZOO",
    "location_name": "ALTERNATIVES OF KALAMAZOO",
    "distance_miles": 13.2345
  },
  {
    "id": 10373,
    "organization_id": 1670,
    "location_id": 1671,
    "source_service_id": 8608,
    "source_id_programAtSite": null,
    "source_id_program": null,
    "source": "data warehouse",
    "program_id": null,
    "program": "STD SERVICES",
    "name": "SEXUALLY TRANSMITTED DISEASE SCREENING",
    "alternate_name": "SEXUALLY TRANSMITTED DISEASE CLINIC,STD CLINIC,STD SCREENING",
    "description": "Testing for gonorrhea, chlamydia, HIV, syphilis, trichomonas, bacterial vaginosis, and yeast infections. An educational session is included with the hope to create a plan to reduce the risks of future STDs. Free pregnancy testing available upon request during STD visit.",
    "url": "www.prcgr.org",
    "email": "info@prcgr.org",
    "status": 1,
    "interpretation_services": null,
    "application_process": "Call for an appointment",
    "wait_time": null,
    "fees": "$20",
    "accreditations": null,
    "licenses": null,
    "eligibility": "Risk assessment is done over the phone",
    "language": "Interpreter available upon request",
    "payment_accepted": "Cash, check, or credit/debit card",
    "required_document": "Valid Picture ID",
    "service_area": "Kent County",
    "area_served_description": "Kent County",
    "region": "HWMI",
    "address_1": "415 Cherry Street SE second",
    "city": "Grand Rapids",
    "county": "Kent",
    "postal_code": "495034601",
    "organization_name": "PREGNANCY RESOURCE CENTER",
    "location_name": "PREGNANCY RESOURCE CENTER",
    "distance_miles": 1.2345
  },
  {
    "id": 10374,
    "organization_id": 1670,
    "location_id": 1671,
    "source_service_id": 8609,
    "source_id_programAtSite": null,
    "source_id_program": null,
    "source": "data warehouse",
    "program_id": null,
    "program": "Test program Banana",
    "name": "Test Name Banana",
    "alternate_name": "Test alternate name Banana",
    "description": "Testing testing and then testing oh so fun. Testing testing and then testing oh so fun. Testing testing and then testing oh so fun. Testing testing and then testing oh so fun. Testing testing and then testing oh so fun. Testing testing and then testing oh so fun. ",
    "url": "www.prcgr.org",
    "email": "info@prcgr.org",
    "status": 1,
    "interpretation_services": null,
    "application_process": "Call for an appointment",
    "wait_time": null,
    "fees": "$20",
    "accreditations": null,
    "licenses": null,
    "eligibility": "Risk assessment is done over the phone",
    "language": "Interpreter available upon request",
    "payment_accepted": "Cash, check, or credit/debit card",
    "required_document": "Valid Picture ID",
    "service_area": "Kent County",
    "area_served_description": "Kent County",
    "region": "HWMI",
    "address_1": "415 Cherry Street SE second",
    "city": "Grand Rapids",
    "county": "Kent",
    "postal_code": "495034601",
    "organization_name": "PREGNANCY RESOURCE CENTER",
    "location_name": "PREGNANCY RESOURCE CENTER",
    "distance_miles": 1.2345
  }
]


const serviceDetailMockedData = [
  {
    "id": 1,
    "organization_id": 969,
    "location_id": 970,
    "source_service_id": 1106,
    "source_id_programAtSite": 80757500,
    "source_id_program": 78143321,
    "source": "icarol",
    "program_id": null,
    "program": "CHILDREN'S ADVOCACY CENTER",
    "name": "COUNSELING SERVICES AND PREVENTION FOR CHILDREN WHO ARE ABUSED",
    "alternate_name": "CHILDREN'S ADVOCACY CENTER",
    "description": "Provides forensic interviews for sexually abused children, counseling services for sexually abused children, including adults survivors of child sexual abuse, and prevention education.",
    "url": "www.swmichigancac.org",
    "email": "info@swmichigancac.org",
    "status": 1,
    "interpretation_services": null,
    "application_process": "Referral required from Child Protective Services or Law Enforcement for forensic interviewing services. Therapy services available to children and adult survivors of child sexual abuse.",
    "wait_time": null,
    "fees": "No fees",
    "accreditations": null,
    "licenses": null,
    "eligibility": "Children and families of suspected child abuse in Southwest Michigan",
    "language": "Interpretation services available",
    "payment_accepted": "Not applicable",
    "required_document": "Referral information",
    "service_area": "Berrien, Cass and Van Buren Counties",
    "area_served_description": "Berrien, Cass and Van Buren Counties",
    "region": "GRYP",
    "contacts": [],
    "regular_schedule": [
      {
        "id": "173709",
        "organization_id": "",
        "service_id": "",
        "source_service_id": "1106",
        "service_at_location_id": "",
        "weekday": "",
        "opens_at": "",
        "closes_at": "",
        "administrative_hours": "",
        "service_hours": "Mon and Wed 8:30am-8pm; Tue and Thu 8:30am-5pm; Fri 8:30am-4pm",
        "site_hours": ""
      }
    ],
    "phones": [
      {
        "id": "378384",
        "organization_id": "",
        "location_id": "",
        "service_id": "",
        "source_service_id": "1106",
        "service_at_location_id": "",
        "number": "1234567890",
        "extension": "",
        "phone_type_hierarchy": "1",
        "type": "Main",
        "department": "",
        "language": "",
        "description": "Test description for phone",
        "confidential": "0"
      },
      {
        "id": "378385",
        "organization_id": "",
        "location_id": "",
        "service_id": "",
        "source_service_id": "1106",
        "service_at_location_id": "",
        "number": "1234567891",
        "extension": "",
        "phone_type_hierarchy": "1",
        "type": "Fax",
        "department": "",
        "language": "",
        "description": "Test description for fax",
        "confidential": "0"
      },
      {
        "id": "378386",
        "organization_id": "",
        "location_id": "",
        "service_id": "",
        "source_service_id": "1106",
        "service_at_location_id": "",
        "number": "1234567892",
        "extension": "777",
        "phone_type_hierarchy": "1",
        "type": "Intake",
        "department": "test department",
        "language": "test language",
        "description": "Test description that is very long and definitely unnecessary and of cource no one will ever read this but never the less it exists and it's long.",
        "confidential": "0"
      }
    ],
    "service_taxonomy": [
      {
        "id": "223017",
        "source_service_id": "1106",
        "taxonomy_id": "FN-1500.1900-150",
        "taxonomy_detail": "Child Abuse Prevention",
        "category": "",
        "subcategory": ""
      },
      {
        "id": "223018",
        "source_service_id": "1106",
        "taxonomy_id": "RP-1400.8000-020.15",
        "taxonomy_detail": "Child Abuse Counseling",
        "category": "Child/Adolescent",
        "subcategory": "Violence/Abuse Services"
      },
      {
        "id": "223019",
        "source_service_id": "1106",
        "taxonomy_id": "RP-1400.8000-020.15",
        "taxonomy_detail": "Child Abuse Counseling",
        "category": "Mental Health Evaluation, Treatment & Supportive Services",
        "subcategory": "Abuse Counseling"
      },
      {
        "id": "223021",
        "source_service_id": "1106",
        "taxonomy_id": "RP-1400.8000-800",
        "taxonomy_detail": "Sexual Assault Counseling",
        "category": "Mental Health Evaluation, Treatment & Supportive Services",
        "subcategory": "Counseling Services"
      }
    ],
    "physical_address": [
      {
        "id": "5559",
        "organization_id": "",
        "location_id": "970",
        "attention": "",
        "address_1": "4938 Niles Road",
        "address_2": "",
        "address_3": "",
        "address_4": "",
        "city": "Saint Joseph",
        "county": "Berrien",
        "region": "",
        "state_province": "MI",
        "postal_code": "49085",
        "country": "USA"
      }
    ],
    "locations": [
      {
        "id": "970",
        "organization_id": "969",
        "organization_name": "CHILDREN'S ADVOCACY CENTER OF SOUTHWEST MICHIGAN",
        "source_id": "",
        "source": "data warehouse",
        "name": "CHILDREN'S ADVOCACY CENTER OF SOUTHWEST MICHIGAN",
        "alternate_name": "",
        "url": "www.swmichigancac.org",
        "description": "Located on Old US 31 near intersection of Marquette Woods Road and US-31",
        "accessibility_for_disabilities": "",
        "transportation": "No public transportation available",
        "latitude": "42.0225356",
        "longitude": "86.4205098"
      }
    ],
    "service_area_served": [
      {
        "id": "126533",
        "service_id": "",
        "source_service_id": "1106",
        "type": "county",
        "name": "Berrien"
      },
      {
        "id": "126534",
        "service_id": "",
        "source_service_id": "1106",
        "type": "county",
        "name": "Cass"
      },
      {
        "id": "126535",
        "service_id": "",
        "source_service_id": "1106",
        "type": "county",
        "name": "Van Buren"
      }
    ]
  }
]

const locationMockedData = [
  {
    "id": 970,
    "organization_id": 969,
    "organization_name": "CHILDREN'S ADVOCACY CENTER OF SOUTHWEST MICHIGAN",
    "source_id": null,
    "source": "data warehouse",
    "name": "CHILDREN'S ADVOCACY CENTER OF SOUTHWEST MICHIGAN",
    "alternate_name": null,
    "url": "www.swmichigancac-location.org",
    "description": "Located on Old US 31 near intersection of Marquette Woods Road and US-31",
    "accessibility_for_disabilities": null,
    "transportation": "No public transportation available",
    "region": "GRYP",
    "latitude": "42.0225356",
    "longitude": "86.4205098"
  }
]

const mockServiceRec = {
  "recommendationId": "d0091e56-75a9-4af2-9f60-ef3445083d84",
  "sessionId": "1",
  "services": [
    {
      "id": 98959,
      "organization_id": 13212,
      "location_id": 13222,
      "source_service_id": 16126,
      "source_id_programAtSite": 78195080,
      "source_id_program": 78148622,
      "source": "icarol",
      "program_id": null,
      "program": "EARLY HEAD START-HOME BASED PROGRAM",
      "name": "EARLY HEAD START AND EXPECTANT/NEW PARENT ASSISTANCE",
      "alternate_name": "EARLY HEAD START-HOME BASED PROGRAM",
      "description": "Provides programming to pregnant moms and infants until children are 3 years old. Enrolled families receive services first in a home based setting and later in center based programming.",
      "url": "https://www.carman.k12.mi.us/Page/2842",
      "email": null,
      "status": 1,
      "interpretation_services": null,
      "application_process": "Telephone to apply",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "- Residents of Bendle and Carman-Ainsworth School Districts - Federal poverty guidelines is used to evaluate family income, call for more information",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "- Proof of residency- Proof of income- Birth certificate for child- Social Security card for child- Medical insurance card for child- Immunization record- Physical exam- DHHS case number, if applicable",
      "service_area": "Carmen-Ainsworth Community School District, Genesee County",
      "area_served_description": "Carmen-Ainsworth Community School District, Genesee County",
      "region": "UWJC",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "319036",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "16126",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-5:30pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "556939",
          "organization_id": "",
          "location_id": "13222",
          "service_id": "",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "8105913600",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Main Site Phone",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "366853",
          "source_service_id": "16126",
          "taxonomy_id": "HD-1800.1800",
          "taxonomy_detail": "Early Head Start",
          "category": "Education",
          "subcategory": "Kindergarten Readiness Program"
        },
        {
          "id": "366854",
          "source_service_id": "16126",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        }
      ],
      "physical_address": [
        {
          "id": "27754",
          "organization_id": "",
          "location_id": "13222",
          "attention": "",
          "address_1": "1181 West Scottwood Avenue",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Flint",
          "county": "Genesee",
          "region": "UWJC",
          "state_province": "MI",
          "postal_code": "48507",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "13222",
          "organization_id": "13212",
          "organization_name": "CARMAN-AINSWORTH COMMUNITY SCHOOLS",
          "source_id": "78178784",
          "source": "icarol",
          "name": "CARMAN-AINSWORTH COMMUNITY SCHOOLS - LEARNING COMMUNITY",
          "alternate_name": "CARMAN AINSWORTH COMMUNITY SCHOOLS,CARMAN-AINSWORTH COMMUNITY SCHOOLS,FENTON LAWN BUILDING",
          "url": "www.carman.k12.mi.us",
          "description": "Located on West Scottwood Avenue, west off of Fenton Road.",
          "accessibility_for_disabilities": "Accessible Restroom,Accessible Parking,No Step Entrance,Wheelchair Accessible Service Area",
          "transportation": "No public transportation available",
          "latitude": "42.9702591",
          "longitude": "83.6980249"
        }
      ],
      "service_area_served": [
        {
          "id": "366025",
          "service_id": "",
          "source_service_id": "16126",
          "type": "county",
          "name": "Genesee"
        }
      ]
    },
    {
      "id": 124932,
      "organization_id": 12926,
      "location_id": 12928,
      "source_service_id": 52506,
      "source_id_programAtSite": 78197407,
      "source_id_program": 78154390,
      "source": "icarol",
      "program_id": null,
      "program": "EARLY HEAD START-HOME BASED PROGRAM",
      "name": "EARLY HEAD START",
      "alternate_name": "EARLY HEAD START-HOME BASED PROGRAM",
      "description": "Provides home-based parent/infant support and intervention services to pregnant people, families with children birth to 3 years, and families with children with a disability. Home visits take place weekly for 90 minutes. There are also two social activities available to families twice per month.",
      "url": "www.gccardheadstart.com",
      "email": "kwebb@co.genesee.mi.us",
      "status": 1,
      "interpretation_services": null,
      "application_process": "- Telephone to apply   - Walk-ins accepted   - Home visits can be made to assist the family with the application if needed",
      "wait_time": null,
      "fees": "No fees/not applicable",
      "accreditations": null,
      "licenses": null,
      "eligibility": "- Residents of Genesee County, with the exception of Beecher and Carman-Ainsworth School Districts - Pregnant individuals - Families with children birth to three years - Families with a child with a disability - Program has income guidelines",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "- Completion of program application  - Proof of income  - Birth certificate",
      "service_area": "Genesee County, with the exception of Beecher and Carman-Ainsworth School Districts",
      "area_served_description": "Genesee County, with the exception of Beecher and Carman-Ainsworth School Districts",
      "region": "UWJC",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "340912",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "52506",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "564297",
          "organization_id": "",
          "location_id": "12928",
          "service_id": "",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "8102355613",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Main Site Phone",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "403640",
          "source_service_id": "52506",
          "taxonomy_id": "HD-1800.1800",
          "taxonomy_detail": "Early Head Start",
          "category": "Education",
          "subcategory": "Kindergarten Readiness Program"
        }
      ],
      "physical_address": [
        {
          "id": "27666",
          "organization_id": "",
          "location_id": "12928",
          "attention": "",
          "address_1": "601 North Saginaw Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Flint",
          "county": "Genesee",
          "region": "UWJC",
          "state_province": "MI",
          "postal_code": "48502",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "12928",
          "organization_id": "12926",
          "organization_name": "GENESEE COUNTY COMMUNITY ACTION RESOURCE DEPARTMENT",
          "source_id": "78177990",
          "source": "icarol",
          "name": "GENESEE COUNTY COMMUNITY ACTION RESOURCE DEPARTMENT - HEAD START/EARLY HEAD START",
          "alternate_name": "EARLY HEAD START",
          "url": "www.gccardheadstart.com",
          "description": "Located on North Saginaw Street and East Fourth Avenue.",
          "accessibility_for_disabilities": "Accessible Parking, No Step Entrance, Wheelchair Accessible Service Area",
          "transportation": "Public transportation available",
          "latitude": "43.0142000",
          "longitude": "83.6889200"
        }
      ],
      "service_area_served": [
        {
          "id": "445327",
          "service_id": "",
          "source_service_id": "52506",
          "type": "county",
          "name": "Genesee"
        }
      ]
    },
    {
      "id": 137157,
      "organization_id": 37165,
      "location_id": 37166,
      "source_service_id": 55774,
      "source_id_programAtSite": 78210400,
      "source_id_program": 78165766,
      "source": "icarol",
      "program_id": null,
      "program": "EARLY HEAD START-HOME BASED PROGRAM",
      "name": "EARLY HEAD START",
      "alternate_name": "EARLY HEAD START-HOME BASED PROGRAM",
      "description": "Offers a child development program for pregnant women, infants and toddlers under age 3.  Weekly visits to your home and monthly socialization for parent(s) and child.",
      "url": "www.bwcaa.org",
      "email": null,
      "status": 1,
      "interpretation_services": null,
      "application_process": "Application required",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Must meet income, residency and age requirements",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Walk-ins accepted  Phone-in",
      "service_area": "Saint Clair County",
      "area_served_description": "Saint Clair County",
      "region": "NEMI",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "319020",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "55774",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 7:12am-2:12pm  Program runs on current school year",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "555705",
          "organization_id": "",
          "location_id": "37166",
          "service_id": "",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "8776270422",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Main Site Phone",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "366833",
          "source_service_id": "55774",
          "taxonomy_id": "HD-1800.1800",
          "taxonomy_detail": "Early Head Start",
          "category": "Education",
          "subcategory": "Kindergarten Readiness Program"
        }
      ],
      "physical_address": [
        {
          "id": "15679",
          "organization_id": "",
          "location_id": "37166",
          "attention": "",
          "address_1": "3403 Lapeer Road",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Port Huron",
          "county": "Saint Clair",
          "region": "NEMI",
          "state_province": "MI",
          "postal_code": "48060",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "37166",
          "organization_id": "37165",
          "organization_name": "BLUE WATER COMMUNITY ACTION",
          "source_id": "78177120",
          "source": "icarol",
          "name": "BLUE WATER COMMUNITY ACTION",
          "alternate_name": "BLUE WATER ACTION AGENCY, COMMUNITY ACTION AGENCY, BLUE WATER COMMUNITY ACTION",
          "url": "www.bwcaa.org",
          "description": "Located in the previous Baker College on Lapeer Road",
          "accessibility_for_disabilities": "Wheelchair Accessible Service Area, Accessible Parking",
          "transportation": "No public transportation available",
          "latitude": "42.9790211",
          "longitude": "82.4680210"
        }
      ],
      "service_area_served": [
        {
          "id": "365997",
          "service_id": "",
          "source_service_id": "55774",
          "type": "county",
          "name": "Saint Clair"
        }
      ]
    },
    {
      "id": 173346,
      "organization_id": 15138,
      "location_id": 49952,
      "source_service_id": 18023,
      "source_id_programAtSite": 81499493,
      "source_id_program": 78161238,
      "source": "icarol",
      "program_id": null,
      "program": "EARLY HEAD START",
      "name": "EARLY HEAD START - HOME BASED",
      "alternate_name": "EARLY HEAD START-HOME BASED",
      "description": "Provides home-based parent/infant support and intervention services to pregnant people, families with children birth to 3 years, and families with children with a disability. Home visits take place weekly for 90 minutes. There are also two social activities available to families twice per month.",
      "url": "www.cacs-inc.org",
      "email": "contact@cacs-inc.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "- Pregnant individuals - Families with children birth to three years - Families with a child with a disability - Program has income guidelines ",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Clinton, Eaton, Ingham, and Shiwassee Counties",
      "area_served_description": "Clinton, Eaton, Ingham, and Shiwassee Counties",
      "region": null,
      "contacts": [
        {
          "id": "59619",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "18023",
          "service_at_location_id": "",
          "name": "Wendy Mcbride",
          "title": "Main",
          "department": "",
          "email": "wendy.mcbride@cacsheadstart.org",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "319034",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "18023",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "597810",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "18023",
          "service_at_location_id": "",
          "number": "5173729411",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        },
        {
          "id": "597811",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "18023",
          "service_at_location_id": "",
          "number": "5173729411",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "366851",
          "source_service_id": "18023",
          "taxonomy_id": "HD-1800.1800",
          "taxonomy_detail": "Early Head Start",
          "category": "Education",
          "subcategory": "Kindergarten Readiness Program"
        }
      ],
      "physical_address": [
        {
          "id": "31906",
          "organization_id": "",
          "location_id": "49952",
          "attention": "",
          "address_1": "727 North Jenison Avenue",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Lansing",
          "county": "Ingham",
          "region": "UWJC",
          "state_province": "MI",
          "postal_code": "48915",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "49952",
          "organization_id": "15138",
          "organization_name": "CAPITAL AREA COMMUNITY SERVICES",
          "source_id": "81499486",
          "source": "icarol",
          "name": "CAPITAL AREA COMMUNITY SERVICES - EARLY HEAD START",
          "alternate_name": "",
          "url": "",
          "description": "Located on North Jenison Avenue, between the intersections of West Saginaw Street and Comfort Street and West Saginaw Street and Westmoreland Avenue.",
          "accessibility_for_disabilities": "",
          "transportation": "",
          "latitude": "42.7417400",
          "longitude": "84.5732100"
        }
      ],
      "service_area_served": [
        {
          "id": "366014",
          "service_id": "",
          "source_service_id": "18023",
          "type": "city",
          "name": "Lansing-Clinton"
        },
        {
          "id": "366015",
          "service_id": "",
          "source_service_id": "18023",
          "type": "city",
          "name": "Lansing-Eaton"
        },
        {
          "id": "366016",
          "service_id": "",
          "source_service_id": "18023",
          "type": "city",
          "name": "Lansing-Ingham"
        },
        {
          "id": "366017",
          "service_id": "",
          "source_service_id": "18023",
          "type": "county",
          "name": "Clinton"
        },
        {
          "id": "366018",
          "service_id": "",
          "source_service_id": "18023",
          "type": "county",
          "name": "Eaton"
        },
        {
          "id": "366019",
          "service_id": "",
          "source_service_id": "18023",
          "type": "county",
          "name": "Ingham"
        },
        {
          "id": "366020",
          "service_id": "",
          "source_service_id": "18023",
          "type": "county",
          "name": "Shiawassee"
        }
      ]
    },
    {
      "id": 173348,
      "organization_id": 15138,
      "location_id": 49953,
      "source_service_id": 18023,
      "source_id_programAtSite": 81499516,
      "source_id_program": 78161238,
      "source": "icarol",
      "program_id": null,
      "program": "EARLY HEAD START",
      "name": "EARLY HEAD START - HOME BASED",
      "alternate_name": "EARLY HEAD START-HOME BASED",
      "description": "Provides home-based parent/infant support and intervention services to pregnant people, families with children birth to 3 years, and families with children with a disability. Home visits take place weekly for 90 minutes. There are also two social activities available to families twice per month.",
      "url": "www.cacs-inc.org",
      "email": "contact@cacs-inc.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "- Pregnant individuals - Families with children birth to three years - Families with a child with a disability - Program has income guidelines ",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Clinton, Eaton, Ingham, and Shiwassee Counties",
      "area_served_description": "Clinton, Eaton, Ingham, and Shiwassee Counties",
      "region": null,
      "contacts": [
        {
          "id": "59619",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "18023",
          "service_at_location_id": "",
          "name": "Wendy Mcbride",
          "title": "Main",
          "department": "",
          "email": "wendy.mcbride@cacsheadstart.org",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "319034",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "18023",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "597810",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "18023",
          "service_at_location_id": "",
          "number": "5173729411",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        },
        {
          "id": "597811",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "18023",
          "service_at_location_id": "",
          "number": "5173729411",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "366851",
          "source_service_id": "18023",
          "taxonomy_id": "HD-1800.1800",
          "taxonomy_detail": "Early Head Start",
          "category": "Education",
          "subcategory": "Kindergarten Readiness Program"
        }
      ],
      "physical_address": [
        {
          "id": "31907",
          "organization_id": "",
          "location_id": "49953",
          "attention": "",
          "address_1": "1107 East Cesar Chavez Avenue",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Lansing",
          "county": "Ingham",
          "region": "UWJC",
          "state_province": "MI",
          "postal_code": "48906",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "49953",
          "organization_id": "15138",
          "organization_name": "CAPITAL AREA COMMUNITY SERVICES",
          "source_id": "81499504",
          "source": "icarol",
          "name": "CAPITAL AREA COMMUNITY SERVICES - GRAND RIVER",
          "alternate_name": "",
          "url": "",
          "description": "Located on East Cesar Chavez Avenue, between the intersections of East Cesar Chavez and North High Street and East Cesar Chavez and Vermont Avenue.",
          "accessibility_for_disabilities": "",
          "transportation": "",
          "latitude": "42.7481700",
          "longitude": "84.5364500"
        }
      ],
      "service_area_served": [
        {
          "id": "366014",
          "service_id": "",
          "source_service_id": "18023",
          "type": "city",
          "name": "Lansing-Clinton"
        },
        {
          "id": "366015",
          "service_id": "",
          "source_service_id": "18023",
          "type": "city",
          "name": "Lansing-Eaton"
        },
        {
          "id": "366016",
          "service_id": "",
          "source_service_id": "18023",
          "type": "city",
          "name": "Lansing-Ingham"
        },
        {
          "id": "366017",
          "service_id": "",
          "source_service_id": "18023",
          "type": "county",
          "name": "Clinton"
        },
        {
          "id": "366018",
          "service_id": "",
          "source_service_id": "18023",
          "type": "county",
          "name": "Eaton"
        },
        {
          "id": "366019",
          "service_id": "",
          "source_service_id": "18023",
          "type": "county",
          "name": "Ingham"
        },
        {
          "id": "366020",
          "service_id": "",
          "source_service_id": "18023",
          "type": "county",
          "name": "Shiawassee"
        }
      ]
    },
    {
      "id": 92110,
      "organization_id": 31786,
      "location_id": 31787,
      "source_service_id": 43199,
      "source_id_programAtSite": 78208561,
      "source_id_program": 78166484,
      "source": "icarol",
      "program_id": null,
      "program": null,
      "name": "EXPECTANT/NEW PARENT ASSISTANCE FOR NATIVE AMERICANS",
      "alternate_name": "FAMILY SPIRIT",
      "description": "Provides support and education during pregnancy and the first five years of a child's life. Services may include health education, community referrals, breast-feeding support, depression screening, and transportation to medical and other appointments. Offers home or office visits by a Maternal Child Health Nurse and Outreach Worker.",
      "url": "www.aihfs.org",
      "email": "info@aihfs.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "- Call for more information  - Intake performed during home visit",
      "wait_time": null,
      "fees": "No fees and no proof of insurance necessary",
      "accreditations": null,
      "licenses": null,
      "eligibility": "- Must be pregnant and/or parenting a child under five years of age - No income restrictions apply",
      "language": "Spanish",
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Livingston, Macomb, Monroe, Oakland, Saint Clair, Washtenaw, and Wayne Counties",
      "area_served_description": "Livingston, Macomb, Monroe, Oakland, Saint Clair, Washtenaw, and Wayne Counties",
      "region": "UWSE",
      "contacts": [
        {
          "id": "64415",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "43199",
          "service_at_location_id": "",
          "name": "Aimee Cisler",
          "title": "Intake",
          "department": "",
          "email": "acisler@aihfs.org",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "341174",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "43199",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 9am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "617694",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "43199",
          "service_at_location_id": "",
          "number": "3138463718",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "404006",
          "source_service_id": "43199",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        },
        {
          "id": "404007",
          "source_service_id": "43199",
          "taxonomy_id": "LJ-5000.6615",
          "taxonomy_detail": "Prenatal/Postnatal Home Visitation Programs",
          "category": "",
          "subcategory": ""
        },
        {
          "id": "404008",
          "source_service_id": "43199",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "404009",
          "source_service_id": "43199",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        }
      ],
      "physical_address": [
        {
          "id": "22049",
          "organization_id": "",
          "location_id": "31787",
          "attention": "",
          "address_1": "4880 Lawndale Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Detroit",
          "county": "Wayne",
          "region": "UWSE",
          "state_province": "MI",
          "postal_code": "48210",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "31787",
          "organization_id": "31786",
          "organization_name": "AMERICAN INDIAN HEALTH AND FAMILY SERVICES",
          "source_id": "78175358",
          "source": "icarol",
          "name": "AMERICAN INDIAN HEALTH AND FAMILY SERVICES",
          "alternate_name": "AIHFS",
          "url": "www.aihfs.org",
          "description": "located off Michigan Ave.  between Wyoming & Lonyo",
          "accessibility_for_disabilities": "Accessible Restroom,Accessible Parking,Wheelchair Accessible Service Area",
          "transportation": "Public transportation available",
          "latitude": "42.3281594",
          "longitude": "83.1469276"
        }
      ],
      "service_area_served": [
        {
          "id": "445978",
          "service_id": "",
          "source_service_id": "43199",
          "type": "county",
          "name": "Livingston"
        },
        {
          "id": "445979",
          "service_id": "",
          "source_service_id": "43199",
          "type": "county",
          "name": "Macomb"
        },
        {
          "id": "445980",
          "service_id": "",
          "source_service_id": "43199",
          "type": "county",
          "name": "Monroe"
        },
        {
          "id": "445981",
          "service_id": "",
          "source_service_id": "43199",
          "type": "county",
          "name": "Oakland"
        },
        {
          "id": "445982",
          "service_id": "",
          "source_service_id": "43199",
          "type": "county",
          "name": "Saint Clair"
        },
        {
          "id": "445983",
          "service_id": "",
          "source_service_id": "43199",
          "type": "county",
          "name": "Washtenaw"
        },
        {
          "id": "445984",
          "service_id": "",
          "source_service_id": "43199",
          "type": "county",
          "name": "Wayne"
        }
      ]
    },
    {
      "id": 168526,
      "organization_id": 23288,
      "location_id": 23289,
      "source_service_id": 65244,
      "source_id_programAtSite": 78218379,
      "source_id_program": 78150193,
      "source": "icarol",
      "program_id": null,
      "program": null,
      "name": "PRENATAL/POSTNATAL HOME BASED PARENTING EDUCATION",
      "alternate_name": "FAMILY SPIRIT",
      "description": "Provides support and education during pregnancy and the first five years of a child's life. Services may include health education, community referrals, breast-feeding support, depression screening, and transportation to medical and other appointments. Offers home or office visits by a Maternal Child Health Nurse and Outreach Worker. Visits range from weekly to monthly depending on the needs of the family and age of the child. Visits generally last between 45-90 minutes.",
      "url": "www.lrboi-nsn.gov",
      "email": "publicinfo@lrboi-nsn.gov",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call or email for more information.",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals Families with children birth to 6 years No income restrictions ",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call or email for more information.",
      "service_area": "Kent, Lake, Manistee, Mason, Muskegon, Newaygo, Oceana, Ottawa, and Wexford Counties",
      "area_served_description": "Kent, Lake, Manistee, Mason, Muskegon, Newaygo, Oceana, Ottawa, and Wexford Counties",
      "region": "CALL",
      "contacts": [
        {
          "id": "62264",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "65244",
          "service_at_location_id": "",
          "name": "Holly Lindsey",
          "title": "Parent Educator",
          "department": "",
          "email": "hollylindsey@lrboi-nsn.gov",
          "hasPhone": "0"
        }
      ],
      "regular_schedule": [
        {
          "id": "331134",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "65244",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Hours vary",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "603967",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "65244",
          "service_at_location_id": "",
          "number": "2316559193",
          "extension": "",
          "phone_type_hierarchy": "4",
          "type": "Intake",
          "department": "",
          "language": "",
          "description": "Parent Educator",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "394148",
          "source_service_id": "65244",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "394149",
          "source_service_id": "65244",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "394151",
          "source_service_id": "65244",
          "taxonomy_id": "LJ-5000.6615",
          "taxonomy_detail": "Prenatal/Postnatal Home Visitation Programs",
          "category": "",
          "subcategory": ""
        }
      ],
      "physical_address": [
        {
          "id": "1570",
          "organization_id": "",
          "location_id": "23289",
          "attention": "",
          "address_1": "2608 Government Center Drive",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Manistee",
          "county": "Manistee",
          "region": "CALL",
          "state_province": "MI",
          "postal_code": "49660",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "23289",
          "organization_id": "23288",
          "organization_name": "LITTLE RIVER BAND OF OTTAWA INDIANS TRIBAL GOVERNMENT (THE)",
          "source_id": "78175844",
          "source": "icarol",
          "name": "LITTLE RIVER BAND OF OTTAWA INDIANS TRIBAL GOVERNMENT (THE)",
          "alternate_name": "LRBOI",
          "url": "www.lrboi-nsn.gov",
          "description": "Located at the corner of Chippewa Highway and Loon Drive",
          "accessibility_for_disabilities": "Accessible Parking,Wheelchair Accessible Service Area",
          "transportation": "Public transportation available",
          "latitude": "44.1764400",
          "longitude": "86.2095600"
        }
      ],
      "service_area_served": [
        {
          "id": "394603",
          "service_id": "",
          "source_service_id": "65244",
          "type": "county",
          "name": "Kent"
        },
        {
          "id": "394604",
          "service_id": "",
          "source_service_id": "65244",
          "type": "county",
          "name": "Lake"
        },
        {
          "id": "394605",
          "service_id": "",
          "source_service_id": "65244",
          "type": "county",
          "name": "Manistee"
        },
        {
          "id": "394606",
          "service_id": "",
          "source_service_id": "65244",
          "type": "county",
          "name": "Mason"
        },
        {
          "id": "394607",
          "service_id": "",
          "source_service_id": "65244",
          "type": "county",
          "name": "Muskegon"
        },
        {
          "id": "394608",
          "service_id": "",
          "source_service_id": "65244",
          "type": "county",
          "name": "Newaygo"
        },
        {
          "id": "394609",
          "service_id": "",
          "source_service_id": "65244",
          "type": "county",
          "name": "Oceana"
        },
        {
          "id": "394610",
          "service_id": "",
          "source_service_id": "65244",
          "type": "county",
          "name": "Ottawa"
        },
        {
          "id": "394611",
          "service_id": "",
          "source_service_id": "65244",
          "type": "county",
          "name": "Wexford"
        }
      ]
    },
    {
      "id": 174263,
      "organization_id": 1233,
      "location_id": 1235,
      "source_service_id": 67344,
      "source_id_programAtSite": 82271920,
      "source_id_program": 82271918,
      "source": "icarol",
      "program_id": null,
      "program": null,
      "name": "PRENATAL/POSTNATAL HOME BASED PARENTING EDUCATION",
      "alternate_name": "FAMILY SPIRIT",
      "description": "Provides support and education during pregnancy and the first five years of a child's life. Services may include health education, community referrals, breast-feeding support, depression screening, and transportation to medical and other appointments. Offers home or office visits by a Maternal Child Health Nurse and Outreach Worker. Visits range from weekly to monthly depending on the needs of the family and age of the child. Visits generally last between 45-90 minutes.",
      "url": "www.pokagonband-nsn.gov/government/departments/zagb%C3%ABgon-early-learning-and-development-academy",
      "email": null,
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals; Families with children birth to 6 years; No income restrictions",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Berrien, Cass and Van Buren Counties",
      "area_served_description": "Berrien, Cass and Van Buren Counties",
      "region": null,
      "contacts": [
        {
          "id": "64355",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "67344",
          "service_at_location_id": "",
          "name": "Elizabeth Leffler",
          "title": "Program Coordinator",
          "department": "",
          "email": "Elizabeth.Leffler@pokagonband-nsn.gov",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "340706",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "67344",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "617021",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "67344",
          "service_at_location_id": "",
          "number": "2694624406",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "403369",
          "source_service_id": "67344",
          "taxonomy_id": "LJ-5000.6615",
          "taxonomy_detail": "Prenatal/Postnatal Home Visitation Programs",
          "category": "",
          "subcategory": ""
        },
        {
          "id": "403370",
          "source_service_id": "67344",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "403371",
          "source_service_id": "67344",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        }
      ],
      "physical_address": [
        {
          "id": "4221",
          "organization_id": "",
          "location_id": "1235",
          "attention": "",
          "address_1": "57392 M-51 South",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Dowagiac",
          "county": "Cass",
          "region": "GRYP",
          "state_province": "MI",
          "postal_code": "49047",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "1235",
          "organization_id": "1233",
          "organization_name": "POKAGON BAND OF POTAWATOMI INDIANS",
          "source_id": "78175298",
          "source": "icarol",
          "name": "POKAGON BAND OF POTAWATOMI INDIANS- INDIAN HEALTH SERVICES",
          "alternate_name": "POKAGON BAND OF POTAWATOMI INDIANS",
          "url": "www.pokagon.com",
          "description": "One mile south of Dowagiac, across from C. Wimberly GM Dealership.",
          "accessibility_for_disabilities": "Accessible Parking,Wheelchair Accessible Service Area,No Step Entrance,No Step Entrance",
          "transportation": "No public transportation available",
          "latitude": "41.9656922",
          "longitude": "86.1428431"
        }
      ],
      "service_area_served": [
        {
          "id": "445018",
          "service_id": "",
          "source_service_id": "67344",
          "type": "county",
          "name": "Berrien"
        },
        {
          "id": "445019",
          "service_id": "",
          "source_service_id": "67344",
          "type": "county",
          "name": "Cass"
        },
        {
          "id": "445020",
          "service_id": "",
          "source_service_id": "67344",
          "type": "county",
          "name": "Van Buren"
        }
      ]
    },
    {
      "id": 174264,
      "organization_id": 38369,
      "location_id": 38370,
      "source_service_id": 67343,
      "source_id_programAtSite": 82271929,
      "source_id_program": 82271925,
      "source": "icarol",
      "program_id": null,
      "program": null,
      "name": "PRENATAL/POSTNATAL HOME BASED PARENTING EDUCATION",
      "alternate_name": "FAMILY SPIRIT",
      "description": "Provides support and education during pregnancy and the first five years of a child's life. Services may include health education, community referrals, breast-feeding support, depression screening, and transportation to medical and other appointments. Offers home or office visits by a Maternal Child Health Nurse and Outreach Worker. Visits range from weekly to monthly depending on the needs of the family and age of the child. Visits generally last between 45-90 minutes.",
      "url": "https://nhbp-nsn.gov/health-and-human-services/community-health/",
      "email": "meg.fairchild@nhbp-nsn.gov",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals; Families with children birth to 6 years; No income restrictions",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Allegan, Barry, Branch, Calhoun, Kalamazoo, Kent and Ottawa counties",
      "area_served_description": "Allegan, Barry, Branch, Calhoun, Kalamazoo, Kent and Ottawa counties",
      "region": null,
      "contacts": [
        {
          "id": "64354",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "67343",
          "service_at_location_id": "",
          "name": "Dawn Cordero-Reyes",
          "title": "Program Coordinator",
          "department": "",
          "email": "dawn.cordero@nhbp.org",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "340705",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "67343",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8:30am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "617020",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "67343",
          "service_at_location_id": "",
          "number": "6162490159",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "403365",
          "source_service_id": "67343",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "403366",
          "source_service_id": "67343",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "403368",
          "source_service_id": "67343",
          "taxonomy_id": "LJ-5000.6615",
          "taxonomy_detail": "Prenatal/Postnatal Home Visitation Programs",
          "category": "",
          "subcategory": ""
        }
      ],
      "physical_address": [
        {
          "id": "4983",
          "organization_id": "",
          "location_id": "38370",
          "attention": "",
          "address_1": "1485 Mno-Bmadzewen Way",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Fulton",
          "county": "Calhoun",
          "region": "GRYP",
          "state_province": "MI",
          "postal_code": "49052",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "38370",
          "organization_id": "38369",
          "organization_name": "NOTTAWASEPPI HURON BAND OF THE POTAWATOMI",
          "source_id": "78181782",
          "source": "icarol",
          "name": "NOTTAWASEPPI HURON BAND OF THE POTAWATOMI",
          "alternate_name": "HURON POTAWATOMI,POTAWATOMI TRIBE,THE POTAWATOMI,NOTTAWASEPPI HURON BAND OF THE POTAWATOMI",
          "url": "www.nhbpi.com",
          "description": "Just south of 44th Street SW",
          "accessibility_for_disabilities": "",
          "transportation": "Public transportation available",
          "latitude": "42.1070500",
          "longitude": "85.3396100"
        }
      ],
      "service_area_served": [
        {
          "id": "445011",
          "service_id": "",
          "source_service_id": "67343",
          "type": "county",
          "name": "Allegan"
        },
        {
          "id": "445012",
          "service_id": "",
          "source_service_id": "67343",
          "type": "county",
          "name": "Barry"
        },
        {
          "id": "445013",
          "service_id": "",
          "source_service_id": "67343",
          "type": "county",
          "name": "Branch"
        },
        {
          "id": "445014",
          "service_id": "",
          "source_service_id": "67343",
          "type": "county",
          "name": "Calhoun"
        },
        {
          "id": "445015",
          "service_id": "",
          "source_service_id": "67343",
          "type": "county",
          "name": "Kalamazoo"
        },
        {
          "id": "445016",
          "service_id": "",
          "source_service_id": "67343",
          "type": "county",
          "name": "Kent"
        },
        {
          "id": "445017",
          "service_id": "",
          "source_service_id": "67343",
          "type": "county",
          "name": "Ottawa"
        }
      ]
    },
    {
      "id": 103775,
      "organization_id": 38077,
      "location_id": 38082,
      "source_service_id": 47616,
      "source_id_programAtSite": 78226751,
      "source_id_program": 78174090,
      "source": "icarol",
      "program_id": null,
      "program": "HEALTHY FAMILIES",
      "name": "HOME BASED PARENTING EDUCATION FOR PARENTS WITH BABIES",
      "alternate_name": "HEALTHY START, HEALTHY FAMILIES",
      "description": "Provides parent education and skill building for at-risk parents to assist children in meeting developmental milestones and accessing appropriate health care. Provides for babies newborn to 3 yrs old, a skilled professional to come to the home and show how talking, singing, and making eye contact can help a baby's brain development.",
      "url": "www.arborcircle.org",
      "email": "earlychildhood@arborcircle.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call to register.",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "- Referrals accepted while pregnant through age 3 months - Services up to age 3 months",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Parts of southeast and southwest Grand Rapids called Hope Zones",
      "area_served_description": "Parts of southeast and southwest Grand Rapids called Hope Zones",
      "region": "HWMI",
      "contacts": [
        {
          "id": "60892",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "47616",
          "service_at_location_id": "",
          "name": "Susan Chang",
          "title": "Program Director",
          "department": "",
          "email": "schang@arborcircle.org",
          "hasPhone": "0"
        }
      ],
      "regular_schedule": [
        {
          "id": "325067",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "47616",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Hours vary. Call for information.",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "553670",
          "organization_id": "",
          "location_id": "38082",
          "service_id": "",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "6164566571",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Main Site Phone",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "380050",
          "source_service_id": "47616",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "380051",
          "source_service_id": "47616",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        }
      ],
      "physical_address": [
        {
          "id": "9693",
          "organization_id": "",
          "location_id": "38082",
          "attention": "",
          "address_1": "1115 Ball Avenue NE",
          "address_2": "Building E",
          "address_3": "",
          "address_4": "",
          "city": "Grand Rapids",
          "county": "Kent",
          "region": "HWMI",
          "state_province": "MI",
          "postal_code": "49505",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "38082",
          "organization_id": "38077",
          "organization_name": "ARBOR CIRCLE",
          "source_id": "78180668",
          "source": "icarol",
          "name": "ARBOR CIRCLE - EARLY CHILDHOOD SERVICES",
          "alternate_name": "",
          "url": "www.arborcircle.org",
          "description": "Near the corner of Leonard Street and Ball Avenue NE.",
          "accessibility_for_disabilities": "",
          "transportation": "Public transportation available",
          "latitude": "42.9826500",
          "longitude": "85.6301300"
        }
      ],
      "service_area_served": [
        {
          "id": "380340",
          "service_id": "",
          "source_service_id": "47616",
          "type": "city",
          "name": "Grand Rapids-Kent"
        },
        {
          "id": "380341",
          "service_id": "",
          "source_service_id": "47616",
          "type": "zipcode",
          "name": "49503"
        },
        {
          "id": "380342",
          "service_id": "",
          "source_service_id": "47616",
          "type": "zipcode",
          "name": "49506"
        },
        {
          "id": "380343",
          "service_id": "",
          "source_service_id": "47616",
          "type": "zipcode",
          "name": "49507"
        }
      ]
    },
    {
      "id": 140367,
      "organization_id": 7015,
      "location_id": 7016,
      "source_service_id": 56680,
      "source_id_programAtSite": 78199255,
      "source_id_program": 78146158,
      "source": "icarol",
      "program_id": null,
      "program": "HEALTHY FAMILIES AMERICA",
      "name": "EXPECTANT/NEW PARENT ASSISTANCE",
      "alternate_name": "HEALTHY FAMILIES AMERICA",
      "description": "Offers an in-home program to new parents with a  focus on child growth and development, positive parent-child interaction, healthy family environments and connects families with community resources.",
      "url": "http://wuphd.org",
      "email": "support@wuphd.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Enrolment period prenatal until 3 months",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "No documentation required",
      "service_area": "Houghton and Keweenaw counties",
      "area_served_description": "Houghton and Keweenaw counties",
      "region": "UPER",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "337872",
          "organization_id": "",
          "service_id": "140367",
          "source_service_id": "",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-4pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "612423",
          "organization_id": "",
          "location_id": "",
          "service_id": "140367",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "9064827382",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "369649",
          "source_service_id": "56680",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        }
      ],
      "physical_address": [
        {
          "id": "17711",
          "organization_id": "",
          "location_id": "7016",
          "attention": "",
          "address_1": "540 Depot Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Hancock",
          "county": "Houghton",
          "region": "UPER",
          "state_province": "MI",
          "postal_code": "49930",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "7016",
          "organization_id": "7015",
          "organization_name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT",
          "source_id": "78183379",
          "source": "icarol",
          "name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT - HOUGHTON OFFICE",
          "alternate_name": "",
          "url": "http://wuphd.org",
          "description": "",
          "accessibility_for_disabilities": "Access w/o Special Facilities,Accessible Parking,Limited Access",
          "transportation": "Public transportation available",
          "latitude": "47.1251666",
          "longitude": "88.5881441"
        }
      ],
      "service_area_served": [
        {
          "id": "433137",
          "service_id": "140367",
          "source_service_id": "",
          "type": "county",
          "name": "Houghton"
        },
        {
          "id": "433138",
          "service_id": "140367",
          "source_service_id": "",
          "type": "county",
          "name": "Keweenaw"
        }
      ]
    },
    {
      "id": 140786,
      "organization_id": 7015,
      "location_id": 7017,
      "source_service_id": 56680,
      "source_id_programAtSite": 78203528,
      "source_id_program": 78146158,
      "source": "icarol",
      "program_id": null,
      "program": "HEALTHY FAMILIES AMERICA",
      "name": "EXPECTANT/NEW PARENT ASSISTANCE",
      "alternate_name": "HEALTHY FAMILIES AMERICA",
      "description": "Offers an in-home program to new parents with a  focus on child growth and development, positive parent-child interaction, healthy family environments and connects families with community resources.",
      "url": "http://wuphd.org",
      "email": "support@wuphd.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Parents with infants under 3 months old",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "No documentation required",
      "service_area": "Baraga County",
      "area_served_description": "Baraga County",
      "region": "UPER",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "337868",
          "organization_id": "",
          "service_id": "140786",
          "source_service_id": "",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Houghton County Office: Mon-Fri 8am-4pmBaraga County Office: Tues-Thurs 8am-4pmOntonagon County Office: Mon-Wed and Fri 8am-4pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "612419",
          "organization_id": "",
          "location_id": "",
          "service_id": "140786",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "9065246142",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "369649",
          "source_service_id": "56680",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        }
      ],
      "physical_address": [
        {
          "id": "17712",
          "organization_id": "",
          "location_id": "7017",
          "attention": "",
          "address_1": "303 Baraga Avenue",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "L'Anse",
          "county": "Baraga",
          "region": "UPER",
          "state_province": "MI",
          "postal_code": "49946",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "7017",
          "organization_id": "7015",
          "organization_name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT",
          "source_id": "78183388",
          "source": "icarol",
          "name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT - BARAGA OFFICE",
          "alternate_name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT",
          "url": "http://wuphd.org",
          "description": "",
          "accessibility_for_disabilities": "",
          "transportation": "No public transportation available",
          "latitude": "46.7597400",
          "longitude": "88.4093400"
        }
      ],
      "service_area_served": [
        {
          "id": "433132",
          "service_id": "140786",
          "source_service_id": "",
          "type": "county",
          "name": "Baraga"
        }
      ]
    },
    {
      "id": 144582,
      "organization_id": 38046,
      "location_id": 38047,
      "source_service_id": 57515,
      "source_id_programAtSite": 78193676,
      "source_id_program": 78157723,
      "source": "icarol",
      "program_id": null,
      "program": "HEALTHY FAMILIES AMERICA",
      "name": "PRENATAL/POSTNATAL HOME VISITATION PROGRAM",
      "alternate_name": "HEALTHY FAMILIES AMERICA",
      "description": "Provides a family-centered program supporting parents during pregnancy and after in building a positive bond between them and their children. Supports child development and growth as well as helping with referrals to healthcare, insurance, and other community resources. Families are offered weekly visits at the beginning of services. How often families have home visits can change depending on their needs. Visits are for 60 minutes",
      "url": "www.kalcounty.com/hcs/mch/hfa/",
      "email": "pio@kalcounty.com",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Once the referral is received the Assessment worker meets with the family/parent to complete a Parent Survey to determine eligibility.",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals; Families with children up to three months; Program has income restrictions",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Referral to program",
      "service_area": "Kalamazoo County",
      "area_served_description": "Kalamazoo County",
      "region": "GRYP",
      "contacts": [
        {
          "id": "64303",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "57515",
          "service_at_location_id": "",
          "name": "Denise Price",
          "title": "Program Coordinator",
          "department": "",
          "email": "dmpric@kalcounty.com",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "340450",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "57515",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "616676",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "57515",
          "service_at_location_id": "",
          "number": "2693735042",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "403045",
          "source_service_id": "57515",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        },
        {
          "id": "403046",
          "source_service_id": "57515",
          "taxonomy_id": "LJ-5000.6615",
          "taxonomy_detail": "Prenatal/Postnatal Home Visitation Programs",
          "category": "",
          "subcategory": ""
        }
      ],
      "physical_address": [
        {
          "id": "4933",
          "organization_id": "",
          "location_id": "38047",
          "attention": "",
          "address_1": "311 East Alcott Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Kalamazoo",
          "county": "Kalamazoo",
          "region": "GRYP",
          "state_province": "MI",
          "postal_code": "49001",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "38047",
          "organization_id": "38046",
          "organization_name": "KALAMAZOO COUNTY HEALTH AND COMMUNITY SERVICES",
          "source_id": "78180538",
          "source": "icarol",
          "name": "KALAMAZOO COUNTY HEALTH AND COMMUNITY SERVICES",
          "alternate_name": "HCS, HEALTH DEPARTMENT, KCHCS,PUBLIC HEALTH, KALAMAZOO COUNTY HEALTH & COMMUNITY SERVICES",
          "url": "www.kalcounty.com/hcs",
          "description": "",
          "accessibility_for_disabilities": "Accessible Restroom, Accessible Parking, Wheelchair Accessible Service Area",
          "transportation": "Public transportation available",
          "latitude": "42.2638800",
          "longitude": "85.4640000"
        }
      ],
      "service_area_served": [
        {
          "id": "444644",
          "service_id": "",
          "source_service_id": "57515",
          "type": "county",
          "name": "Kalamazoo"
        }
      ]
    },
    {
      "id": 148935,
      "organization_id": 9032,
      "location_id": 9033,
      "source_service_id": 58672,
      "source_id_programAtSite": 78199311,
      "source_id_program": 78145080,
      "source": "icarol",
      "program_id": null,
      "program": "HEALTHY FAMILIES AMERICA",
      "name": "EXPECTANT/NEW PARENT ASSISTANCE",
      "alternate_name": "HEALTHY FAMILIES AMERICA",
      "description": "Provides home visitors who support parents in building a relationship to assure healthy child growth and development. Home visitors support parents in cultivating and strengthening a nurturing, positive relationship with their baby at each visit. Parents receive information on topics like child development, infant care and keeping their baby healthy, and get connected to other events and programs to their communities that help to support new families.",
      "url": "www.lmasdhd.org",
      "email": null,
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for intake interview",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Admission into the program must be prenatally or before the baby is 3 months old",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "No documentation required",
      "service_area": "Luce County",
      "area_served_description": "Luce County",
      "region": "UPER",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "320167",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "58672",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "No set hours",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "612406",
          "organization_id": "",
          "location_id": "",
          "service_id": "148935",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "9062935107",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "369646",
          "source_service_id": "58672",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        }
      ],
      "physical_address": [
        {
          "id": "18639",
          "organization_id": "",
          "location_id": "9033",
          "attention": "",
          "address_1": "14150 Hamilton Lake Road",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Newberry",
          "county": "Luce",
          "region": "UPER",
          "state_province": "MI",
          "postal_code": "49868",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "9033",
          "organization_id": "9032",
          "organization_name": "LUCE-MACKINAC-ALGER-SCHOOLCRAFT DISTRICT HEALTH DEPARTMENT",
          "source_id": "78177643",
          "source": "icarol",
          "name": "LUCE-MACKINAC-ALGER-SCHOOLCRAFT DISTRICT HEALTH DEPARTMENT - LUCE COUNTY OFFICE",
          "alternate_name": "",
          "url": "www.lmasdhd.org",
          "description": "",
          "accessibility_for_disabilities": "Accessible Parking,Wheelchair Accessible Service Area",
          "transportation": "No public transportation available",
          "latitude": "46.3446680",
          "longitude": "85.5081120"
        }
      ],
      "service_area_served": [
        {
          "id": "433092",
          "service_id": "148935",
          "source_service_id": "",
          "type": "county",
          "name": "Luce"
        }
      ]
    },
    {
      "id": 148936,
      "organization_id": 9032,
      "location_id": 9034,
      "source_service_id": 58672,
      "source_id_programAtSite": 78199340,
      "source_id_program": 78145080,
      "source": "icarol",
      "program_id": null,
      "program": "HEALTHY FAMILIES AMERICA",
      "name": "EXPECTANT/NEW PARENT ASSISTANCE",
      "alternate_name": "HEALTHY FAMILIES AMERICA",
      "description": "Provides home visitors who support parents in building a relationship to assure healthy child growth and development. Home visitors support parents in cultivating and strengthening a nurturing, positive relationship with their baby at each visit. Parents receive information on topics like child development, infant care and keeping their baby healthy, and get connected to other events and programs to their communities that help to support new families.",
      "url": "www.lmasdhd.org",
      "email": null,
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for intake interview",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Admission into the program must be prenatally or before the baby is 3 months old",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "No documentation required",
      "service_area": "Alger County",
      "area_served_description": "Alger County",
      "region": "UPER",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "320167",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "58672",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "No set hours",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "612405",
          "organization_id": "",
          "location_id": "",
          "service_id": "148936",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "9063872297",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "369646",
          "source_service_id": "58672",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        }
      ],
      "physical_address": [
        {
          "id": "18640",
          "organization_id": "",
          "location_id": "9034",
          "attention": "",
          "address_1": "E9526 Prospect Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Munising",
          "county": "Alger",
          "region": "UPER",
          "state_province": "MI",
          "postal_code": "49862",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "9034",
          "organization_id": "9032",
          "organization_name": "LUCE-MACKINAC-ALGER-SCHOOLCRAFT DISTRICT HEALTH DEPARTMENT",
          "source_id": "78177647",
          "source": "icarol",
          "name": "LUCE-MACKINAC-ALGER-SCHOOLCRAFT DISTRICT HEALTH DEPARTMENT - ALGER COUNTY OFFICE",
          "alternate_name": "LUCE-MACKINAC-ALGER-SCHOOLCRAFT DISTRICT HEALTH DEPARTMENT,LMAS DISTRICT HEALTH DEPARTMENT",
          "url": "www.lmasdhd.org",
          "description": "",
          "accessibility_for_disabilities": "Access without special facilities,Limited Access",
          "transportation": "No public transportation available",
          "latitude": "46.4164200",
          "longitude": "86.6239800"
        }
      ],
      "service_area_served": [
        {
          "id": "433091",
          "service_id": "148936",
          "source_service_id": "",
          "type": "county",
          "name": "Alger"
        }
      ]
    },
    {
      "id": 1751,
      "organization_id": 2666,
      "location_id": 2667,
      "source_service_id": 3327,
      "source_id_programAtSite": 78200293,
      "source_id_program": 78161514,
      "source": "icarol",
      "program_id": null,
      "program": "INFANT MENTAL HEALTH",
      "name": "HOME BASED INFANT AND EARLY CHILDHOOD MENTAL HEALTH",
      "alternate_name": "INFANT MENTAL HEALTH",
      "description": "Provides support to pregnant people, parents,and caregivers who may be having trouble bonding with their child. Families may enroll during pregnancy through their child’s third birthday. Services generally begin after child is born but may begin during pregnancy. The frequency and duration of visitsis based on family needs.",
      "url": "www.montcalmcare.net",
      "email": "info@montcalmcare.net",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "Sliding scale based on income",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals; Families of children ages birth to three; Income restrictions apply",
      "language": "Interpreters availabe upon request at no charge",
      "payment_accepted": "Private pay, Medicaid, Medicare and other private insurances",
      "required_document": "Call for more information",
      "service_area": "Montcalm County",
      "area_served_description": "Montcalm County",
      "region": "GRYP",
      "contacts": [
        {
          "id": "60866",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "3327",
          "service_at_location_id": "",
          "name": "Liz Ingraham",
          "title": "Program Coordinator",
          "department": "",
          "email": "eingraham@montcalmcare.net",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "325016",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "3327",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-5pm; evenings by appointment",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "600759",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "3327",
          "service_at_location_id": "",
          "number": "9898317520",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "379885",
          "source_service_id": "3327",
          "taxonomy_id": "RP-6400.3300",
          "taxonomy_detail": "Infant and Early Childhood Mental Health",
          "category": "Mental Health Evaluation, Treatment & Supportive Services",
          "subcategory": "Psychiatric Services"
        }
      ],
      "physical_address": [
        {
          "id": "4770",
          "organization_id": "",
          "location_id": "2667",
          "attention": "",
          "address_1": "611 North State Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Stanton",
          "county": "Montcalm",
          "region": "GRYP",
          "state_province": "MI",
          "postal_code": "48888",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "2667",
          "organization_id": "2666",
          "organization_name": "MONTCALM CARE NETWORK",
          "source_id": "78178771",
          "source": "icarol",
          "name": "MONTCALM CARE NETWORK",
          "alternate_name": "HEARTLAND HOUSE,MCN,MCN BALDWIND STREET OFFICE,MCN HEALTH360 CLINIC,MONTCALM CENTER FOR BEHAVIORAL HEALTH,MCN BALDWIN STREET OFFICE,WELLNESS WORKS",
          "url": "www.montcalmcare.net",
          "description": "",
          "accessibility_for_disabilities": "Accessible Restroom,Accessible Parking,No Step Entrance,Wheelchair Accessible Service Area",
          "transportation": "No public transportation available",
          "latitude": "43.3014609",
          "longitude": "85.0848838"
        }
      ],
      "service_area_served": [
        {
          "id": "380198",
          "service_id": "",
          "source_service_id": "3327",
          "type": "county",
          "name": "Montcalm"
        }
      ]
    },
    {
      "id": 17844,
      "organization_id": 17104,
      "location_id": 17105,
      "source_service_id": 19909,
      "source_id_programAtSite": 78210328,
      "source_id_program": 78172549,
      "source": "icarol",
      "program_id": null,
      "program": null,
      "name": "HOME BASED INFANT AND EARLY CHILDHOOD MENTAL HEALTH",
      "alternate_name": "INFANT MENTAL HEALTH",
      "description": "Provides support to pregnant people, parents, and caregivers who may be having trouble bonding with their child. Families may enroll during pregnancy through their child’s third birthday. Services generally begin after child is born but may begin during pregnancy. The frequency and duration of visits is based on family needs.",
      "url": "www.facebook/JacksonHillsdaleIMHChapter",
      "email": "abricker@integroservices.net",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals Families of children ages birth to three  Income restrictions apply",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Hillsdale and Jackson Counties",
      "area_served_description": "Hillsdale and Jackson Counties",
      "region": "MICH",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "341379",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "19909",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "- Meeting hours: Meetings held quarterly, on third Mon of Month, 12:30pm-    2pm   - See Facebook web page for meeting schedule   - Meeting Location: Artesian Wells, 18711 US-12, Cement City, MI   - Currently meeting virtually monthly to mitigate COVID-19 risk.   - For virtual meeting link, contact email: abricker@integroservices.net",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "617867",
          "organization_id": "",
          "location_id": "17105",
          "service_id": "",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "5172500213",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Main Site Phone",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "404347",
          "source_service_id": "19909",
          "taxonomy_id": "RP-6400.3300",
          "taxonomy_detail": "Infant and Early Childhood Mental Health",
          "category": "Mental Health Evaluation, Treatment & Supportive Services",
          "subcategory": "Psychiatric Services"
        }
      ],
      "physical_address": [
        {
          "id": "28755",
          "organization_id": "",
          "location_id": "17105",
          "attention": "",
          "address_1": "1360 South Hillsdale Road",
          "address_2": "Suite 231",
          "address_3": "",
          "address_4": "",
          "city": "Hillsdale",
          "county": "Hillsdale",
          "region": "MICH",
          "state_province": "MI",
          "postal_code": "49242",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "17105",
          "organization_id": "17104",
          "organization_name": "JACKSON HILLSDALE INFANT MENTAL HEALTH CHAPTER",
          "source_id": "78187408",
          "source": "icarol",
          "name": "JACKSON HILLSDALE INFANT MENTAL HEALTH CHAPTER",
          "alternate_name": "JCAIMH, JHCAIMH, JACKSON COUNTY ASSOCIATION FOR INFANT MENTAL HEALTH, HILLSDALE INTEGRO, MI ASSOCIATION OF INFANT MENTAL HEALTH, MICHIGAN ASSOCIATION OF INFANT MENTAL HEALTH",
          "url": "www.facebook/JacksonHillsdaleIMHChapter",
          "description": "Located on South Hillsdale Road, between West Bacon Road and Foust Road.",
          "accessibility_for_disabilities": "",
          "transportation": "No public transportation available",
          "latitude": "41.9293200",
          "longitude": "84.6426600"
        }
      ],
      "service_area_served": [
        {
          "id": "446337",
          "service_id": "",
          "source_service_id": "19909",
          "type": "county",
          "name": "Hillsdale"
        },
        {
          "id": "446338",
          "service_id": "",
          "source_service_id": "19909",
          "type": "county",
          "name": "Jackson"
        }
      ]
    },
    {
      "id": 62015,
      "organization_id": 27037,
      "location_id": 27038,
      "source_service_id": 32124,
      "source_id_programAtSite": 78207113,
      "source_id_program": 78169974,
      "source": "icarol",
      "program_id": null,
      "program": null,
      "name": "HOME BASED INFANT AND EARLY CHILDHOOD MENTAL HEALTH",
      "alternate_name": "INFANT MENTAL HEALTH",
      "description": "Provides support to pregnant people, parents and caregivers, who may be having trouble bonding with their child. Families may enroll during pregnancy through their child’s third birthday. Services generally begin after child is born but may begin during pregnancy. The frequency and duration of visits is based on family needs.",
      "url": "www.avcmh.org",
      "email": null,
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals Families of children ages birth to three  Income restrictions apply",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Ogemaw, Iosco, and Oscoda Counties",
      "area_served_description": "Ogemaw, Iosco, and Oscoda Counties",
      "region": "NEMI",
      "contacts": [
        {
          "id": "64290",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "32124",
          "service_at_location_id": "",
          "name": "Morgan Wynkoop",
          "title": "",
          "department": "",
          "email": "morgan.wynkoop@avcmh.org",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "340419",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "32124",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon 8am-7pm, Tue-Fri 8am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "616658",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "32124",
          "service_at_location_id": "",
          "number": "9893059464",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "402957",
          "source_service_id": "32124",
          "taxonomy_id": "RP-6400.3300",
          "taxonomy_detail": "Infant and Early Childhood Mental Health",
          "category": "Mental Health Evaluation, Treatment & Supportive Services",
          "subcategory": "Psychiatric Services"
        }
      ],
      "physical_address": [
        {
          "id": "14948",
          "organization_id": "",
          "location_id": "27038",
          "attention": "",
          "address_1": "1199 West Harris Avenue",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Tawas City",
          "county": "Iosco",
          "region": "NEMI",
          "state_province": "MI",
          "postal_code": "48764",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "27038",
          "organization_id": "27037",
          "organization_name": "AUSABLE VALLEY COMMUNITY MENTAL HEALTH SERVICES",
          "source_id": "78188464",
          "source": "icarol",
          "name": "AUSABLE VALLEY COMMUNITY MENTAL HEALTH HEALTH SERVICES - TAWAS",
          "alternate_name": "AUSABLE CMH, OSCODA CMH, IOSCO CMH, OGEMAW CMH",
          "url": "www.avcmh.org",
          "description": "",
          "accessibility_for_disabilities": "Wheelchair accessible",
          "transportation": "No public transportation available",
          "latitude": "44.2717779",
          "longitude": "83.5312307"
        }
      ],
      "service_area_served": [
        {
          "id": "433453",
          "service_id": "62015",
          "source_service_id": "",
          "type": "county",
          "name": "Ogemaw"
        }
      ]
    },
    {
      "id": 69475,
      "organization_id": 27459,
      "location_id": 27460,
      "source_service_id": 32748,
      "source_id_programAtSite": 78204804,
      "source_id_program": 78147618,
      "source": "icarol",
      "program_id": null,
      "program": "CHILDRENS SERVICES",
      "name": "HOME BASED INFANT AND EARLY CHILDHOOD MENTAL HEALTH",
      "alternate_name": "INFANT MENTAL HEALTH",
      "description": "Provides support to pregnant people, parents and caregivers who may be having trouble bonding with their child. Families may enroll during pregnancy through their child’s third birthday. Services generally begin after child is born but may begin during pregnancy. The frequency and duration of visits is based on family needs.",
      "url": "www.huroncmh.org",
      "email": null,
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals Families of children ages birth to three  Income restrictions apply",
      "language": "Additional languages may be available as needed",
      "payment_accepted": "Medicaid",
      "required_document": "Call for more information",
      "service_area": "Huron County",
      "area_served_description": "Huron County",
      "region": "NEMI",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "339225",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "32748",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8:30am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "568552",
          "organization_id": "",
          "location_id": "27460",
          "service_id": "",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "9892699293",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Main Site Phone",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "401389",
          "source_service_id": "32748",
          "taxonomy_id": "RP-6400.3300",
          "taxonomy_detail": "Infant and Early Childhood Mental Health",
          "category": "Mental Health Evaluation, Treatment & Supportive Services",
          "subcategory": "Psychiatric Services"
        }
      ],
      "physical_address": [
        {
          "id": "15274",
          "organization_id": "",
          "location_id": "27460",
          "attention": "",
          "address_1": "1375 R Dale Wertz Drive",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Bad Axe",
          "county": "Huron",
          "region": "NEMI",
          "state_province": "MI",
          "postal_code": "48413",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "27460",
          "organization_id": "27459",
          "organization_name": "HURON BEHAVIORAL HEALTH MEMBER OF MID - STATE HEALTH NETWORK",
          "source_id": "78176019",
          "source": "icarol",
          "name": "HURON BEHAVIORAL HEALTH MEMBER OF MID - STATE HEALTH NETWORK",
          "alternate_name": "CMH, HURON BEHAVIORAL HEALTH",
          "url": "www.huroncmh.org",
          "description": "",
          "accessibility_for_disabilities": "",
          "transportation": "Public transportation available",
          "latitude": "43.8044200",
          "longitude": "82.9968600"
        }
      ],
      "service_area_served": [
        {
          "id": "442809",
          "service_id": "",
          "source_service_id": "32748",
          "type": "county",
          "name": "Huron"
        }
      ]
    },
    {
      "id": 71573,
      "organization_id": 27472,
      "location_id": 28975,
      "source_service_id": 35044,
      "source_id_programAtSite": 78215810,
      "source_id_program": 78169130,
      "source": "icarol",
      "program_id": null,
      "program": "HOME BASED INFANT AND EARLY CHILDHOOD MENTAL HEALTH",
      "name": "HOME BASED INFANT AND EARLY CHILDHOOD MENTAL HEALTH",
      "alternate_name": "INFANT MENTAL HEALTH",
      "description": "Provides support to pregnant people, parents and caregivers, who may be having trouble bonding with their child. Families may enroll during pregnancy through their child’s third birthday. Services generally begin after child is born but may begin during pregnancy. The frequency and duration of visits is based on family needs.",
      "url": "www.babha.org",
      "email": null,
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals  Families of children ages birth to three  Income restrictions apply",
      "language": "Additional languages may be available as needed",
      "payment_accepted": "MedicaidCall for details",
      "required_document": "Call for more information",
      "service_area": "Arenac and Bay County",
      "area_served_description": "Arenac and Bay County",
      "region": "NEMI",
      "contacts": [
        {
          "id": "64151",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "35044",
          "service_at_location_id": "",
          "name": "Pamela VanWormer",
          "title": "",
          "department": "",
          "email": "pvanwormer@babha.org",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "339088",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "35044",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8:30am-5pm  Other times by appointment",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "614825",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "35044",
          "service_at_location_id": "",
          "number": "9898952676",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "401208",
          "source_service_id": "35044",
          "taxonomy_id": "RP-6400.3300",
          "taxonomy_detail": "Infant and Early Childhood Mental Health",
          "category": "Mental Health Evaluation, Treatment & Supportive Services",
          "subcategory": "Psychiatric Services"
        }
      ],
      "physical_address": [
        {
          "id": "15282",
          "organization_id": "",
          "location_id": "28975",
          "attention": "",
          "address_1": "1010 North Madison",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Bay City",
          "county": "Bay",
          "region": "NEMI",
          "state_province": "MI",
          "postal_code": "48708",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "28975",
          "organization_id": "27472",
          "organization_name": "BAY ARENAC BEHAVIORAL HEALTH",
          "source_id": "78181709",
          "source": "icarol",
          "name": "BAY ARENAC BEHAVIORAL HEALTH MADISON BUILDING",
          "alternate_name": "BAY ARENAC BEHAVIORAL HEALTH PART OF ACCESS ALLIANCE, CMH, BEHAVIORAL HEALTH",
          "url": "www.babha.org",
          "description": "",
          "accessibility_for_disabilities": "Wheelchair accessible",
          "transportation": "Public transportation available",
          "latitude": "43.5999202",
          "longitude": "83.8841451"
        }
      ],
      "service_area_served": [
        {
          "id": "439098",
          "service_id": "71573",
          "source_service_id": "",
          "type": "county",
          "name": "Arenac"
        },
        {
          "id": "439099",
          "service_id": "71573",
          "source_service_id": "",
          "type": "county",
          "name": "Bay"
        }
      ]
    },
    {
      "id": 76859,
      "organization_id": 27472,
      "location_id": 28971,
      "source_service_id": 35044,
      "source_id_programAtSite": 78196511,
      "source_id_program": 78169130,
      "source": "icarol",
      "program_id": null,
      "program": "HOME BASED INFANT AND EARLY CHILDHOOD MENTAL HEALTH",
      "name": "HOME BASED INFANT AND EARLY CHILDHOOD MENTAL HEALTH",
      "alternate_name": "INFANT MENTAL HEALTH",
      "description": "Provides support to pregnant people, parents and caregivers, who may be having trouble bonding with their child. Families may enroll during pregnancy through their child’s third birthday. Services generally begin after child is born but may begin during pregnancy. The frequency and duration of visits is based on family needs.",
      "url": "www.babha.org",
      "email": null,
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals  Families of children ages birth to three  Income restrictions apply",
      "language": "Additional languages may be available as needed",
      "payment_accepted": "MedicaidCall for details",
      "required_document": "Call for more information",
      "service_area": "Arenac and Bay County",
      "area_served_description": "Arenac and Bay County",
      "region": "NEMI",
      "contacts": [
        {
          "id": "64151",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "35044",
          "service_at_location_id": "",
          "name": "Pamela VanWormer",
          "title": "",
          "department": "",
          "email": "pvanwormer@babha.org",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "339088",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "35044",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8:30am-5pm  Other times by appointment",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "613729",
          "organization_id": "",
          "location_id": "",
          "service_id": "76859",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "8004485498",
          "extension": "",
          "phone_type_hierarchy": "4",
          "type": "Intake",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "401208",
          "source_service_id": "35044",
          "taxonomy_id": "RP-6400.3300",
          "taxonomy_detail": "Infant and Early Childhood Mental Health",
          "category": "Mental Health Evaluation, Treatment & Supportive Services",
          "subcategory": "Psychiatric Services"
        }
      ],
      "physical_address": [
        {
          "id": "15281",
          "organization_id": "",
          "location_id": "28971",
          "attention": "",
          "address_1": "1000 West Cedar",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Standish",
          "county": "Arenac",
          "region": "NEMI",
          "state_province": "MI",
          "postal_code": "48658",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "28971",
          "organization_id": "27472",
          "organization_name": "BAY ARENAC BEHAVIORAL HEALTH",
          "source_id": "78181705",
          "source": "icarol",
          "name": "ARENAC CENTER TREATMENT CLINIC",
          "alternate_name": "CMH, BEHAVIORAL HEALTH",
          "url": "www.babha.org",
          "description": "",
          "accessibility_for_disabilities": "Wheelchair accessible",
          "transportation": "Public transportation available",
          "latitude": "43.9829368",
          "longitude": "83.9713291"
        }
      ],
      "service_area_served": [
        {
          "id": "439096",
          "service_id": "76859",
          "source_service_id": "",
          "type": "county",
          "name": "Arenac"
        },
        {
          "id": "439097",
          "service_id": "76859",
          "source_service_id": "",
          "type": "county",
          "name": "Bay"
        }
      ]
    },
    {
      "id": 1741,
      "organization_id": 1806,
      "location_id": 1807,
      "source_service_id": 2273,
      "source_id_programAtSite": 78200196,
      "source_id_program": 78153962,
      "source": "icarol",
      "program_id": null,
      "program": "MATERNAL INFANT HEALTH PROGRAM",
      "name": "EXPECTANT/NEW PARENT ASSISTANCE IN THE HOME",
      "alternate_name": "MATERNAL INFANT HEALTH PROGRAM",
      "description": "Provides home visitation support and care coordination for pregnant women and infants on Medicaid. Services are provided by registered nurses, licensed medical social workers, and a registered dietician. Currently offering home or telemedicine options.",
      "url": "www.accesskent.com/health",
      "email": "karen.sall@kentcountymi.gov",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "- Pregnant women and/or families with infants. - Must have Medicaid. - If Medicaid eligible but are not currently covered, staff can assist with applying.",
      "language": "All",
      "payment_accepted": "Medicaid",
      "required_document": "Call for more information",
      "service_area": "Kent County",
      "area_served_description": "Kent County",
      "region": "HWMI",
      "contacts": [
        {
          "id": "59911",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "2273",
          "service_at_location_id": "",
          "name": "",
          "title": "",
          "department": "",
          "email": "karen.sall@kentcountymi.gov",
          "hasPhone": "0"
        }
      ],
      "regular_schedule": [
        {
          "id": "320239",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "2273",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "598445",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "2273",
          "service_at_location_id": "",
          "number": "6166327058",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "369796",
          "source_service_id": "2273",
          "taxonomy_id": "LF-4900.6200",
          "taxonomy_detail": "Nutrition Assessment Services",
          "category": "",
          "subcategory": ""
        },
        {
          "id": "369797",
          "source_service_id": "2273",
          "taxonomy_id": "LH-2700.6000",
          "taxonomy_detail": "Nutrition Education",
          "category": "",
          "subcategory": ""
        },
        {
          "id": "369798",
          "source_service_id": "2273",
          "taxonomy_id": "LH-6300.5500",
          "taxonomy_detail": "Medical Social Work",
          "category": "",
          "subcategory": ""
        },
        {
          "id": "369799",
          "source_service_id": "2273",
          "taxonomy_id": "LJ-2000.1000-100",
          "taxonomy_detail": "Birth Control Counseling",
          "category": "",
          "subcategory": ""
        },
        {
          "id": "369800",
          "source_service_id": "2273",
          "taxonomy_id": "LJ-5000.1000",
          "taxonomy_detail": "Breastfeeding Support Programs",
          "category": "",
          "subcategory": ""
        },
        {
          "id": "369801",
          "source_service_id": "2273",
          "taxonomy_id": "LJ-5000.6600",
          "taxonomy_detail": "Prenatal Care",
          "category": "",
          "subcategory": ""
        },
        {
          "id": "369802",
          "source_service_id": "2273",
          "taxonomy_id": "LV-8500",
          "taxonomy_detail": "Telemedicine",
          "category": "",
          "subcategory": ""
        },
        {
          "id": "369803",
          "source_service_id": "2273",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        },
        {
          "id": "369804",
          "source_service_id": "2273",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "369805",
          "source_service_id": "2273",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "369807",
          "source_service_id": "2273",
          "taxonomy_id": "TJ-3000.8000",
          "taxonomy_detail": "Specialized Information and Referral",
          "category": "",
          "subcategory": ""
        },
        {
          "id": "369808",
          "source_service_id": "2273",
          "taxonomy_id": "TJ-3000.8000 * YK-6500.6600",
          "taxonomy_detail": "Specialized Information and Referral * Pregnant Women",
          "category": "",
          "subcategory": ""
        }
      ],
      "physical_address": [
        {
          "id": "8376",
          "organization_id": "",
          "location_id": "1807",
          "attention": "",
          "address_1": "700 Fuller Avenue NE",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Grand Rapids",
          "county": "Kent",
          "region": "HWMI",
          "state_province": "MI",
          "postal_code": "49503",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "1807",
          "organization_id": "1806",
          "organization_name": "KENT COUNTY HEALTH DEPARTMENT",
          "source_id": "78176855",
          "source": "icarol",
          "name": "KENT COUNTY HEALTH DEPARTMENT",
          "alternate_name": "",
          "url": "www.accesskent.com/health",
          "description": "Just north of the Fuller Avenue/ I-196 exit.",
          "accessibility_for_disabilities": "",
          "transportation": "Public transportation available",
          "latitude": "42.9763700",
          "longitude": "85.6397000"
        }
      ],
      "service_area_served": [
        {
          "id": "368748",
          "service_id": "",
          "source_service_id": "2273",
          "type": "county",
          "name": "Kent"
        }
      ]
    },
    {
      "id": 10986,
      "organization_id": 7015,
      "location_id": 7016,
      "source_service_id": 8853,
      "source_id_programAtSite": 78194952,
      "source_id_program": 78149966,
      "source": "icarol",
      "program_id": null,
      "program": "MATERNAL INFANT HEALTH PROGRAM",
      "name": "EXPECTANT/NEW PARENT ASSISTANCE",
      "alternate_name": "MATERNAL INFANT HEALTH PROGRAM",
      "description": "Support service program that provides home visiting assistance in learning skills related to nutrition, growth and development, parenting issues and breast feeding.",
      "url": "http://wuphd.org",
      "email": "support@wuphd.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant women and children under the age of 1, who are eligible for Medicaid",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Medicaid card",
      "service_area": "Houghton and Keweenaw counties",
      "area_served_description": "Houghton and Keweenaw counties",
      "region": "UPER",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "337871",
          "organization_id": "",
          "service_id": "10986",
          "source_service_id": "",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-4pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "612422",
          "organization_id": "",
          "location_id": "",
          "service_id": "10986",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "9064827382",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "369660",
          "source_service_id": "8853",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        }
      ],
      "physical_address": [
        {
          "id": "17711",
          "organization_id": "",
          "location_id": "7016",
          "attention": "",
          "address_1": "540 Depot Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Hancock",
          "county": "Houghton",
          "region": "UPER",
          "state_province": "MI",
          "postal_code": "49930",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "7016",
          "organization_id": "7015",
          "organization_name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT",
          "source_id": "78183379",
          "source": "icarol",
          "name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT - HOUGHTON OFFICE",
          "alternate_name": "",
          "url": "http://wuphd.org",
          "description": "",
          "accessibility_for_disabilities": "Access w/o Special Facilities,Accessible Parking,Limited Access",
          "transportation": "Public transportation available",
          "latitude": "47.1251666",
          "longitude": "88.5881441"
        }
      ],
      "service_area_served": [
        {
          "id": "433135",
          "service_id": "10986",
          "source_service_id": "",
          "type": "county",
          "name": "Houghton"
        },
        {
          "id": "433136",
          "service_id": "10986",
          "source_service_id": "",
          "type": "county",
          "name": "Keweenaw"
        }
      ]
    },
    {
      "id": 10987,
      "organization_id": 7015,
      "location_id": 7017,
      "source_service_id": 8853,
      "source_id_programAtSite": 78194977,
      "source_id_program": 78149966,
      "source": "icarol",
      "program_id": null,
      "program": "MATERNAL INFANT HEALTH PROGRAM",
      "name": "EXPECTANT/NEW PARENT ASSISTANCE",
      "alternate_name": "MATERNAL INFANT HEALTH PROGRAM",
      "description": "Support service program that provides home visiting assistance in learning skills related to nutrition, growth and development, parenting issues and breast feeding.",
      "url": "http://wuphd.org",
      "email": "support@wuphd.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant women and children under the age of 1, who are eligible for Medicaid",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Medicaid card",
      "service_area": "Baraga County",
      "area_served_description": "Baraga County",
      "region": "UPER",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "337869",
          "organization_id": "",
          "service_id": "10987",
          "source_service_id": "",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Houghton County: Mon-Fri 8am-4pm Gogebic County: Mon-Fri 8am-4pm (CST)Baraga County: Tues-Thurs 8am-4pmOntonagon County: Mon, Tues, Wed and Fri 8am-4pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "612420",
          "organization_id": "",
          "location_id": "",
          "service_id": "10987",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "9065246142",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "369660",
          "source_service_id": "8853",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        }
      ],
      "physical_address": [
        {
          "id": "17712",
          "organization_id": "",
          "location_id": "7017",
          "attention": "",
          "address_1": "303 Baraga Avenue",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "L'Anse",
          "county": "Baraga",
          "region": "UPER",
          "state_province": "MI",
          "postal_code": "49946",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "7017",
          "organization_id": "7015",
          "organization_name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT",
          "source_id": "78183388",
          "source": "icarol",
          "name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT - BARAGA OFFICE",
          "alternate_name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT",
          "url": "http://wuphd.org",
          "description": "",
          "accessibility_for_disabilities": "",
          "transportation": "No public transportation available",
          "latitude": "46.7597400",
          "longitude": "88.4093400"
        }
      ],
      "service_area_served": [
        {
          "id": "433133",
          "service_id": "10987",
          "source_service_id": "",
          "type": "county",
          "name": "Baraga"
        }
      ]
    },
    {
      "id": 10988,
      "organization_id": 7015,
      "location_id": 7018,
      "source_service_id": 8853,
      "source_id_programAtSite": 78195010,
      "source_id_program": 78149966,
      "source": "icarol",
      "program_id": null,
      "program": "MATERNAL INFANT HEALTH PROGRAM",
      "name": "EXPECTANT/NEW PARENT ASSISTANCE",
      "alternate_name": "MATERNAL INFANT HEALTH PROGRAM",
      "description": "Support service program that provides home visiting assistance in learning skills related to nutrition, growth and development, parenting issues and breast feeding.",
      "url": "www.wuphd.org",
      "email": "support@wuphd.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant women and children under the age of 1, who are eligible for Medicaid",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Medicaid card",
      "service_area": "Ontonagon County",
      "area_served_description": "Ontonagon County",
      "region": "UPER",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "337873",
          "organization_id": "",
          "service_id": "10988",
          "source_service_id": "",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Houghton County: Mon-Fri 8am-4pm Gogebic County: Mon-Fri 8am-4pm (CST)Baraga County: Tues-Thurs 8am-4pmOntonagon County: Mon, Tues, Wed and Fri 8am-4pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "612424",
          "organization_id": "",
          "location_id": "",
          "service_id": "10988",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "9068844485",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "369660",
          "source_service_id": "8853",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        }
      ],
      "physical_address": [
        {
          "id": "17713",
          "organization_id": "",
          "location_id": "7018",
          "attention": "",
          "address_1": "408 Copper Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Ontonagon",
          "county": "Ontonagon",
          "region": "UPER",
          "state_province": "MI",
          "postal_code": "49953",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "7018",
          "organization_id": "7015",
          "organization_name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT",
          "source_id": "78183397",
          "source": "icarol",
          "name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT - ONTONAGON OFFICE",
          "alternate_name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT",
          "url": "www.wuphd.org",
          "description": "",
          "accessibility_for_disabilities": "",
          "transportation": "Public transportation available",
          "latitude": "46.8556060",
          "longitude": "89.3158170"
        }
      ],
      "service_area_served": [
        {
          "id": "433139",
          "service_id": "10988",
          "source_service_id": "",
          "type": "county",
          "name": "Ontonagon"
        }
      ]
    },
    {
      "id": 10989,
      "organization_id": 7015,
      "location_id": 7019,
      "source_service_id": 8853,
      "source_id_programAtSite": 78195031,
      "source_id_program": 78149966,
      "source": "icarol",
      "program_id": null,
      "program": "MATERNAL INFANT HEALTH PROGRAM",
      "name": "EXPECTANT/NEW PARENT ASSISTANCE",
      "alternate_name": "MATERNAL INFANT HEALTH PROGRAM",
      "description": "Support service program that provides home visiting assistance in learning skills related to nutrition, growth and development, parenting issues and breast feeding.",
      "url": "www.wuphd.org",
      "email": "support@wuphd.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant women and children under the age of 1, who are eligible for Medicaid",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Medicaid card",
      "service_area": "Gogebic County",
      "area_served_description": "Gogebic County",
      "region": "UPER",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "337870",
          "organization_id": "",
          "service_id": "10989",
          "source_service_id": "",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Houghton County: Mon-Fri 8am-4pm Gogebic County: Mon-Fri 8am-4pm (CST)Baraga County: Tues-Thurs 8am-4pmOntonagon County: Mon, Tues, Wed and Fri 8am-4pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "612421",
          "organization_id": "",
          "location_id": "",
          "service_id": "10989",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "9066670200",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "369660",
          "source_service_id": "8853",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        }
      ],
      "physical_address": [
        {
          "id": "17714",
          "organization_id": "",
          "location_id": "7019",
          "attention": "",
          "address_1": "210 North Moore Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Bessemer",
          "county": "Gogebic",
          "region": "UPER",
          "state_province": "MI",
          "postal_code": "49911",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "7019",
          "organization_id": "7015",
          "organization_name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT",
          "source_id": "78183405",
          "source": "icarol",
          "name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT - GOGEBIC OFFICE",
          "alternate_name": "WESTERN UPPER PENINSULA HEALTH DEPARTMENT",
          "url": "www.wuphd.org",
          "description": "",
          "accessibility_for_disabilities": "",
          "transportation": "No public transportation available",
          "latitude": "46.4820258",
          "longitude": "90.0524324"
        }
      ],
      "service_area_served": [
        {
          "id": "433134",
          "service_id": "10989",
          "source_service_id": "",
          "type": "county",
          "name": "Gogebic"
        }
      ]
    },
    {
      "id": 17065,
      "organization_id": 17244,
      "location_id": 17245,
      "source_service_id": 20037,
      "source_id_programAtSite": 78207084,
      "source_id_program": 78173397,
      "source": "icarol",
      "program_id": null,
      "program": "MATERNAL INFANT HEALTH PROGRAM",
      "name": "PRENATAL/POSTNATAL HOME VISITATION PROGRAM",
      "alternate_name": "MATERNAL INFANT HEALTH PROGRAM, MIHP",
      "description": "Provides home visits by a nurse and social worder who perform health assessments and coordinate care and support during pregnancy and for infants and caregivers. Other specialist may visit including an infant mental health specialist, registerd dietician, or lactation consultant as needed. Services include immunizations support, well-childvisit support, health and childbirth education referrals, transportation, and connection with local community resources. Visits are offered monthly, but may be more frequent. Pregnant person may receive up to nine visits throughout the pregnancy and after delivery, Infants enrolled in the program can receive up to 36 visits, depending on the needs of the infant and caregiver. Home visits may continue until the infant reaches 18 months of age based on the needs of the infant and caregiver",
      "url": "www.mijackson.org/hd",
      "email": "jchd@mijackson.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "- Pregnant individual - Families with children birth to 12 months - Program has income restrictions",
      "language": "Interpretation services available",
      "payment_accepted": "Not applicable",
      "required_document": "Specific document requirements will be given",
      "service_area": "Jackson County",
      "area_served_description": "Jackson County",
      "region": "UWJC",
      "contacts": [
        {
          "id": "62272",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "20037",
          "service_at_location_id": "",
          "name": "Ann Sloan",
          "title": "Main",
          "department": "",
          "email": "asloan@co.jackson.mi.us",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "331147",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "20037",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "- Mon, Tue, Thu, and Fri 8am-3:30pm (Closed 11:30am-1pm)  - Second Tue of month 8am-6pm (Closed 11:30am-1pm)  - Clinic hours can vary; call to confirm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "603976",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "20037",
          "service_at_location_id": "",
          "number": "5177682114",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        },
        {
          "id": "603977",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "20037",
          "service_at_location_id": "",
          "number": "5177682114",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        },
        {
          "id": "603978",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "20037",
          "service_at_location_id": "",
          "number": "5177682114",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "Community Health Coordinator",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "394165",
          "source_service_id": "20037",
          "taxonomy_id": "LJ-5000.6615",
          "taxonomy_detail": "Prenatal/Postnatal Home Visitation Programs",
          "category": "",
          "subcategory": ""
        }
      ],
      "physical_address": [
        {
          "id": "28797",
          "organization_id": "",
          "location_id": "17245",
          "attention": "",
          "address_1": "1715 Lansing Avenue",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Jackson",
          "county": "Jackson",
          "region": "UWJC",
          "state_province": "MI",
          "postal_code": "49202",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "17245",
          "organization_id": "17244",
          "organization_name": "JACKSON COUNTY HEALTH DEPARTMENT",
          "source_id": "78187805",
          "source": "icarol",
          "name": "JACKSON COUNTY HEALTH DEPARTMENT",
          "alternate_name": "JCHD",
          "url": "www.mijackson.org/hd",
          "description": "Located near the intersection of Lansing Avenue and Andrew Avenue. Health Department is in the same building as Jackson County Department on Aging, and MSU Extension.",
          "accessibility_for_disabilities": "Accessible Parking, Limited Access, No Step Entrance",
          "transportation": "Public transportation available",
          "latitude": "42.2681500",
          "longitude": "84.4162100"
        }
      ],
      "service_area_served": [
        {
          "id": "394638",
          "service_id": "",
          "source_service_id": "20037",
          "type": "county",
          "name": "Jackson"
        }
      ]
    },
    {
      "id": 175,
      "organization_id": 1143,
      "location_id": 1144,
      "source_service_id": 1201,
      "source_id_programAtSite": 78189392,
      "source_id_program": 78144274,
      "source": "icarol",
      "program_id": null,
      "program": "NURSE-FAMILY PARTNERSHIP",
      "name": "PRENATAL/POSTNATAL HOME VISITATION PROGRAMS",
      "alternate_name": "NURSE FAMILY PARTNERSHIP, MOTHER AND INFANT CARE AND CHILD DEVELOPMENT CLASSES",
      "description": "Provides personalized home visits by registered nurses to pregnant and postpartum people and their infants, with enrollment prior to 28 weeks pregnant. Services include prenatal health and childbirth education, infant health, child developmental screenings, practical tips on positive parenting techniques to promote strong parent-child relationships, connection to community services, and encouragement to help families reach their life goals. Families receive weekly, biweekly, or monthly visits dependent on length of enrollment and age of the child. Visiting schedule is determined by the family and can be changed based on family needs.",
      "url": "www.bchdmi.org/650/Nurse-Family-Partnership-NFP",
      "email": "bchd@bchdmi.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "First time pregnant individuals who are less than 28 weeks pregnant; Program has income restrictions",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Berrien County",
      "area_served_description": "Berrien County",
      "region": "GRYP",
      "contacts": [
        {
          "id": "62276",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "1201",
          "service_at_location_id": "",
          "name": "Jacque Clement",
          "title": "Program Coordinator",
          "department": "",
          "email": "jclement@bchdmi.org",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "331153",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "1201",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8:30am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "603983",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "1201",
          "service_at_location_id": "",
          "number": "2699725631",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "394172",
          "source_service_id": "1201",
          "taxonomy_id": "LJ-5000.6615",
          "taxonomy_detail": "Prenatal/Postnatal Home Visitation Programs",
          "category": "",
          "subcategory": ""
        }
      ],
      "physical_address": [
        {
          "id": "4182",
          "organization_id": "",
          "location_id": "1144",
          "attention": "",
          "address_1": "2149 Napier Avenue",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Benton Harbor",
          "county": "Berrien",
          "region": "GRYP",
          "state_province": "MI",
          "postal_code": "49023",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "1144",
          "organization_id": "1143",
          "organization_name": "BERRIEN COUNTY HEALTH DEPARTMENT",
          "source_id": "78174944",
          "source": "icarol",
          "name": "BERRIEN COUNTY HEALTH DEPARTMENT",
          "alternate_name": "",
          "url": "www.bchdmi.org",
          "description": "At the intersection of I-94 & Napier ave",
          "accessibility_for_disabilities": "Accessible Parking, No Step Entrance, Wheelchair Accessible Service Area",
          "transportation": "Public transportation available",
          "latitude": "42.1075430",
          "longitude": "86.4660510"
        }
      ],
      "service_area_served": [
        {
          "id": "410365",
          "service_id": "175",
          "source_service_id": "",
          "type": "county",
          "name": "Berrien"
        }
      ]
    },
    {
      "id": 176,
      "organization_id": 1143,
      "location_id": 1149,
      "source_service_id": 1201,
      "source_id_programAtSite": 78189404,
      "source_id_program": 78144274,
      "source": "icarol",
      "program_id": null,
      "program": "NURSE FAMILY PARTNERSHIP",
      "name": "PRENATAL/POSTNATAL HOME VISITATION PROGRAMS",
      "alternate_name": "NURSE FAMILY PARTNERSHIP, MOTHER AND INFANT CARE AND CHILD DEVELOPMENT CLASSES",
      "description": "Provides a Pre-natal and Early Childhood program for high risk, low income first-time mothers and their child through the age of two years. Registered nurses make home visits that are appropriate to the developmental stages of pregnancy and early childhood.  Program goals are to improve pregnancy outcomes, support child health and development and foster economic self-sufficiency.",
      "url": "www.bchdmi.org/650/Nurse-Family-Partnership-NFP",
      "email": "bchd@bchdmi.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "First time pregnant individuals who are less than 28 weeks pregnant; Program has income restrictions",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Berrien County",
      "area_served_description": "Berrien County",
      "region": "GRYP",
      "contacts": [
        {
          "id": "62276",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "1201",
          "service_at_location_id": "",
          "name": "Jacque Clement",
          "title": "Program Coordinator",
          "department": "",
          "email": "jclement@bchdmi.org",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "331153",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "1201",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8:30am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "603983",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "1201",
          "service_at_location_id": "",
          "number": "2699725631",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "394172",
          "source_service_id": "1201",
          "taxonomy_id": "LJ-5000.6615",
          "taxonomy_detail": "Prenatal/Postnatal Home Visitation Programs",
          "category": "",
          "subcategory": ""
        }
      ],
      "physical_address": [
        {
          "id": "4183",
          "organization_id": "",
          "location_id": "1149",
          "attention": "",
          "address_1": "1205 North Front Street",
          "address_2": "Suite 900",
          "address_3": "",
          "address_4": "",
          "city": "Niles",
          "county": "Berrien",
          "region": "GRYP",
          "state_province": "MI",
          "postal_code": "49120",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "1149",
          "organization_id": "1143",
          "organization_name": "BERRIEN COUNTY HEALTH DEPARTMENT",
          "source_id": "78174954",
          "source": "icarol",
          "name": "BERRIEN COUNTY HEALTH DEPARTMENT- SOUTH COUNTY BUILDING",
          "alternate_name": "",
          "url": "www.bchdmi.org",
          "description": "",
          "accessibility_for_disabilities": "Wheelchair Accessible Service Area, No Step Entrance",
          "transportation": "No public transportation available",
          "latitude": "41.8403600",
          "longitude": "86.2609600"
        }
      ],
      "service_area_served": [
        {
          "id": "410369",
          "service_id": "176",
          "source_service_id": "",
          "type": "county",
          "name": "Berrien"
        }
      ]
    },
    {
      "id": 7603,
      "organization_id": 1806,
      "location_id": 1807,
      "source_service_id": 6329,
      "source_id_programAtSite": 78223018,
      "source_id_program": 78171047,
      "source": "icarol",
      "program_id": null,
      "program": "NURSE FAMILY PARTNERSHIP",
      "name": "PEDIATRIC HOME NURSING FOR FIRST TIME MOMS",
      "alternate_name": "NURSE FAMILY PARTNERSHIP",
      "description": "Gives first-time moms their own free, personal nurse to provide support, advice, and information during pregnancy and when baby arrives.",
      "url": "www.accesskent.com/health",
      "email": null,
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call to apply. Moms can text the national service office at (844) 637-6667 if they would like more info via text instead of calling the office.",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "- Pregnant women who are going to be first-time moms- Less than 28 weeks gestation- Low income",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for details",
      "service_area": "Kent County",
      "area_served_description": "Kent County",
      "region": "HWMI",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "330449",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "6329",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "- Mon-Fri 8am-5pm- Some flexibility for home visits after 5pm.",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "603636",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "6329",
          "service_at_location_id": "",
          "number": "6166327058",
          "extension": "",
          "phone_type_hierarchy": "7",
          "type": "Alternate",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        },
        {
          "id": "603637",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "6329",
          "service_at_location_id": "",
          "number": "6166327178",
          "extension": "",
          "phone_type_hierarchy": "1",
          "type": "Main",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "392809",
          "source_service_id": "6329",
          "taxonomy_id": "LT-2800.3100-600",
          "taxonomy_detail": "Pediatric Home Nursing",
          "category": "",
          "subcategory": ""
        },
        {
          "id": "392810",
          "source_service_id": "6329",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "392811",
          "source_service_id": "6329",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        }
      ],
      "physical_address": [
        {
          "id": "8376",
          "organization_id": "",
          "location_id": "1807",
          "attention": "",
          "address_1": "700 Fuller Avenue NE",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Grand Rapids",
          "county": "Kent",
          "region": "HWMI",
          "state_province": "MI",
          "postal_code": "49503",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "1807",
          "organization_id": "1806",
          "organization_name": "KENT COUNTY HEALTH DEPARTMENT",
          "source_id": "78176855",
          "source": "icarol",
          "name": "KENT COUNTY HEALTH DEPARTMENT",
          "alternate_name": "",
          "url": "www.accesskent.com/health",
          "description": "Just north of the Fuller Avenue/ I-196 exit.",
          "accessibility_for_disabilities": "",
          "transportation": "Public transportation available",
          "latitude": "42.9763700",
          "longitude": "85.6397000"
        }
      ],
      "service_area_served": [
        {
          "id": "392766",
          "service_id": "",
          "source_service_id": "6329",
          "type": "county",
          "name": "Kent"
        }
      ]
    },
    {
      "id": 91970,
      "organization_id": 31409,
      "location_id": 31410,
      "source_service_id": 43113,
      "source_id_programAtSite": 78207622,
      "source_id_program": 78165930,
      "source": "icarol",
      "program_id": null,
      "program": "NURSE FAMILY PARTNERSHIP",
      "name": "EXPECTANT/NEW PARENT ASSISTANCE",
      "alternate_name": "NURSE FAMILY PARTNERSHIP",
      "description": "Provides personalized home visits by registered nurses to pregnant and postpartum people and their infants, with enrollment prior to 28 weeks pregnant. Services include prenatal health and childbirth education, infant health, child developmental screenings, practical tips on positive parenting techniques to promote strong parent-child relationships, connection to community services, and encouragement to help families reach their life goals. Families receive weekly, biweekly, or monthly visits dependent on length of enrollment and age of the child. Visiting schedule is determined by the family and can be changed based on family needs.",
      "url": "www.oakgov.com/health",
      "email": "health@oakgov.com",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "First time pregnant individuals who are less than 28 weeks pregnant Program has income restrictions",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Pontiac",
      "area_served_description": "Pontiac",
      "region": "UWSE",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "340922",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "43113",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8:30-5pm except legal holidays",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "617334",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "43113",
          "service_at_location_id": "",
          "number": "2488581406",
          "extension": "",
          "phone_type_hierarchy": "4",
          "type": "Intake",
          "department": "",
          "language": "",
          "description": "Nurse Family Partnership",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "403669",
          "source_service_id": "43113",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        },
        {
          "id": "403670",
          "source_service_id": "43113",
          "taxonomy_id": "LJ-5000.6615",
          "taxonomy_detail": "Prenatal/Postnatal Home Visitation Programs",
          "category": "",
          "subcategory": ""
        }
      ],
      "physical_address": [
        {
          "id": "21852",
          "organization_id": "",
          "location_id": "31410",
          "attention": "",
          "address_1": "1200 North Telegraph Road",
          "address_2": "Building 34 East",
          "address_3": "",
          "address_4": "",
          "city": "Pontiac",
          "county": "Oakland",
          "region": "UWSE",
          "state_province": "MI",
          "postal_code": "48341",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "31410",
          "organization_id": "31409",
          "organization_name": "OAKLAND COUNTY HEALTH DIVISION",
          "source_id": "78188292",
          "source": "icarol",
          "name": "OAKLAND COUNTY HEALTH DIVISION",
          "alternate_name": "OCHD,NORTH OAKLAND HEALTH CENTER",
          "url": "www.oakgov.com/health",
          "description": "Located north of Elizabeth Lake Road, South of Oakland Avenue / Dixie Hwy on North Telegraph Road",
          "accessibility_for_disabilities": "Accessible Parking,Wheelchair Accessible Service Area",
          "transportation": "Public transportation available",
          "latitude": "42.6411700",
          "longitude": "83.3046500"
        }
      ],
      "service_area_served": [
        {
          "id": "445369",
          "service_id": "",
          "source_service_id": "43113",
          "type": "city",
          "name": "Pontiac"
        }
      ]
    },
    {
      "id": 102669,
      "organization_id": 38046,
      "location_id": 38047,
      "source_service_id": 46457,
      "source_id_programAtSite": 78218520,
      "source_id_program": 78162590,
      "source": "icarol",
      "program_id": null,
      "program": "NURSE FAMILY PARTNERSHIP",
      "name": "PRENATAL/POSTNATAL HOME VISITATION PROGRAMS",
      "alternate_name": "NURSE FAMILY PARTNERSHIP",
      "description": "Provides personalized home visits by registered nurses to pregnant and postpartum people and their infants, with enrollment prior to 28 weeks pregnant. Services include prenatal health and childbirth education, infant health, child developmental screenings, practical tips on positive parenting techniques to promote strong parent-child relationships, connection to community services, and encouragement to help families reach their life goals. Families receive weekly, biweekly, or monthly visits dependent on length of enrollment and age of the child. Visiting schedule is determined by the family and can be changed based on family needs.",
      "url": "www.kalcounty.com/hcs/mch/nfp/",
      "email": "pio@kalcounty.com",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "First time pregnant individuals who are less than 28 weeks pregnant; Program has income restrictions",
      "language": "Translators can be arranged as needed",
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Kalamazoo County",
      "area_served_description": "Kalamazoo County",
      "region": "GRYP",
      "contacts": [
        {
          "id": "64304",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "46457",
          "service_at_location_id": "",
          "name": "Elon Bridges",
          "title": "Program Coordinator",
          "department": "",
          "email": "edbrid@kalcounty.com",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "340451",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "46457",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "616677",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "46457",
          "service_at_location_id": "",
          "number": "2693735067",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        },
        {
          "id": "616678",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "46457",
          "service_at_location_id": "",
          "number": "2698885437",
          "extension": "",
          "phone_type_hierarchy": "6",
          "type": "Hotline",
          "department": "",
          "language": "",
          "description": "Cradle Hotline",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "403047",
          "source_service_id": "46457",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        }
      ],
      "physical_address": [
        {
          "id": "4933",
          "organization_id": "",
          "location_id": "38047",
          "attention": "",
          "address_1": "311 East Alcott Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Kalamazoo",
          "county": "Kalamazoo",
          "region": "GRYP",
          "state_province": "MI",
          "postal_code": "49001",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "38047",
          "organization_id": "38046",
          "organization_name": "KALAMAZOO COUNTY HEALTH AND COMMUNITY SERVICES",
          "source_id": "78180538",
          "source": "icarol",
          "name": "KALAMAZOO COUNTY HEALTH AND COMMUNITY SERVICES",
          "alternate_name": "HCS, HEALTH DEPARTMENT, KCHCS,PUBLIC HEALTH, KALAMAZOO COUNTY HEALTH & COMMUNITY SERVICES",
          "url": "www.kalcounty.com/hcs",
          "description": "",
          "accessibility_for_disabilities": "Accessible Restroom, Accessible Parking, Wheelchair Accessible Service Area",
          "transportation": "Public transportation available",
          "latitude": "42.2638800",
          "longitude": "85.4640000"
        }
      ],
      "service_area_served": [
        {
          "id": "444645",
          "service_id": "",
          "source_service_id": "46457",
          "type": "county",
          "name": "Kalamazoo"
        }
      ]
    },
    {
      "id": 111705,
      "organization_id": 40585,
      "location_id": 40586,
      "source_service_id": 49241,
      "source_id_programAtSite": 78193610,
      "source_id_program": 78155201,
      "source": "icarol",
      "program_id": null,
      "program": "NURSE FAMILY PARTNERSHIP",
      "name": "PRENATAL/POSTNATAL HOME VISITATION PROGRAMS",
      "alternate_name": "NURSE FAMILY PARTNERSHIP",
      "description": "Provides personalized home visits by registered nurses to pregnant and postpartum people and their infants, with enrollment prior to 28 weeks pregnant. Services include prenatal health and childbirth education, infant health, child developmental screenings, practical tips on positive parenting techniques to promote strong parent-child relationships, connection to community services, and encouragement to help families reach their life goals. Families receive weekly, biweekly, or monthly visits dependent on length of enrollment and age of the child. Visiting schedule is determined by the family and can be changed based on family needs.",
      "url": "www.calhouncountymi.gov/publichealth",
      "email": "publichealth@calhouncountymi.gov",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "First time pregnant individuals who are less than 28 weeks pregnant; Program has income restrictions",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Calhoun County",
      "area_served_description": "Calhoun County",
      "region": "GRYP",
      "contacts": [
        {
          "id": "62274",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "49241",
          "service_at_location_id": "",
          "name": "Michelle Datema",
          "title": "Project Coordinator",
          "department": "",
          "email": "mdatema@calhouncountymi.gov",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "331150",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "49241",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Thu 7am-12:30pm and 1pm-4:30pm, Fri 8am-12noon",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "603980",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "49241",
          "service_at_location_id": "",
          "number": "2699696392",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "394169",
          "source_service_id": "49241",
          "taxonomy_id": "PH-6100.1800",
          "taxonomy_detail": "Expectant/New Parent Assistance",
          "category": "Child Care",
          "subcategory": " Expectant/New Parent Assistance"
        }
      ],
      "physical_address": [
        {
          "id": "5032",
          "organization_id": "",
          "location_id": "40586",
          "attention": "",
          "address_1": "190 East Michigan Avenue",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Battle Creek",
          "county": "Calhoun",
          "region": "GRYP",
          "state_province": "MI",
          "postal_code": "49014",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "40586",
          "organization_id": "40585",
          "organization_name": "CALHOUN COUNTY PUBLIC HEALTH DEPARTMENT",
          "source_id": "78187872",
          "source": "icarol",
          "name": "CALHOUN COUNTY PUBLIC HEALTH DEPARTMENT",
          "alternate_name": "CCPHD,CALHOUN COUNTY HEALTH DEPARTMENT",
          "url": "www.calhouncountymi.gov/publichealth",
          "description": "Next to The Haven of Rest Ministries. Across the street from the Justice Center and Battle Creek Fire Department Station.",
          "accessibility_for_disabilities": "Accessible Restroom,Accessible Parking,No Step Entrance,Wheelchair Accessible Service Area",
          "transportation": "No public transportation available",
          "latitude": "42.3154490",
          "longitude": "85.1764265"
        }
      ],
      "service_area_served": [
        {
          "id": "394643",
          "service_id": "",
          "source_service_id": "49241",
          "type": "county",
          "name": "Calhoun"
        }
      ]
    },
    {
      "id": 378,
      "organization_id": 1277,
      "location_id": 1278,
      "source_service_id": 1400,
      "source_id_programAtSite": 78191429,
      "source_id_program": 78147065,
      "source": "icarol",
      "program_id": null,
      "program": "PARENTS AS TEACHERS",
      "name": "HOME BASED PARENTING EDUCATION",
      "alternate_name": "PARENTS AS TEACHERS PROGRAM",
      "description": "Provides personalized home visits, by certified parent educators trained in child development, to pregnant peopleand families with children from birth to kindergarten. Enrollment can occur at any point during this time. Supportsparents' understanding of what to expect in each stage of their child's development.Offers practical tips on ways to encourage learning, manage challenging behavior, and promote strong parent-child relationships. Group meetings are held for parents to gain new insights and to share their experiences, common concerns,and successes. Offers periodic screening of child's overall development, language, hearing,and vision.Families can receive monthly to twice monthly visits, depending on family needs. Home Visits are generally 60 minutes. Families are also offered 12 group connections per year.",
      "url": "www.berrienresa.org/services_for_young_children__0-5____families",
      "email": "info@berrienresa.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals; Families with children from birth to kindergarten entry; No income guidelines",
      "language": "Call for more information",
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Berrien County",
      "area_served_description": "Berrien County",
      "region": "GRYP",
      "contacts": [
        {
          "id": "60888",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "1400",
          "service_at_location_id": "",
          "name": "Patrick Conley",
          "title": "Program Coordinator",
          "department": "",
          "email": "patrick.conley@berrienresa.org",
          "hasPhone": "0"
        }
      ],
      "regular_schedule": [
        {
          "id": "325059",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "1400",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-4:30pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "555357",
          "organization_id": "",
          "location_id": "1278",
          "service_id": "",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "2694717725",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Main Site Phone",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "380025",
          "source_service_id": "1400",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "380026",
          "source_service_id": "1400",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        }
      ],
      "physical_address": [
        {
          "id": "4243",
          "organization_id": "",
          "location_id": "1278",
          "attention": "",
          "address_1": "711 Saint Joseph Avenue",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Berrien Springs",
          "county": "Berrien",
          "region": "GRYP",
          "state_province": "MI",
          "postal_code": "49103",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "1278",
          "organization_id": "1277",
          "organization_name": "BERRIEN REGIONAL EDUCATION SERVICE AGENCY",
          "source_id": "78175523",
          "source": "icarol",
          "name": "BERRIEN REGIONAL EDUCATION SERVICE AGENCY",
          "alternate_name": "BCISD, BERRIEN COUNTY ISD, BERRIEN COUNTY INTERMEDIATE SCHOOL DISTRICT, BERRIEN RESA",
          "url": "www.berrienresa.org",
          "description": "Located 1.5 miles south of the US 31 bypass off exit 15.",
          "accessibility_for_disabilities": "Accessible Parking, No Step Entrance, Wheelchair Accessible Service Area",
          "transportation": "No public transportation available",
          "latitude": "41.9517300",
          "longitude": "86.3477000"
        }
      ],
      "service_area_served": [
        {
          "id": "380328",
          "service_id": "",
          "source_service_id": "1400",
          "type": "county",
          "name": "Berrien"
        }
      ]
    },
    {
      "id": 25181,
      "organization_id": 15918,
      "location_id": 15919,
      "source_service_id": 18974,
      "source_id_programAtSite": 78208794,
      "source_id_program": 78165258,
      "source": "icarol",
      "program_id": null,
      "program": "PARENTS AS TEACHERS",
      "name": "HOME BASED PARENTING EDUCATION",
      "alternate_name": "PARENTS AS TEACHERS",
      "description": "Provides personalized home visits, by certified parent educators trained in child development, to pregnant peopleand families with children from birth to kindergarten. Enrollment can occur at any point during this time. Supportsparents' understanding of what to expect in each stage of their child's development.Offers practical tips on ways to encourage learning, manage challenging behavior, and promote strong parent-child relationships. Group meetings are held for parents to gain new insights and to share their experiences, common concerns,and successes. Offers periodic screening of child's overall development, language, hearing,and vision.Families can receive monthly to twice monthly visits, depending on family needs. Home Visits are generally 60 minutes. Families are also offered 12 group connections per year.",
      "url": "www.eatonresa.org/early-childhood//eaton-great-start",
      "email": "nselleck@eatonresa.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "- Pregnant individuals - Families with children from birth to kindergarten entry - No income guidelines",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Eaton County/Eaton RESA service area",
      "area_served_description": "Eaton County/Eaton RESA service area",
      "region": "UWJC",
      "contacts": [
        {
          "id": "60882",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "18974",
          "service_at_location_id": "",
          "name": "Nikki Selleck",
          "title": "Main",
          "department": "",
          "email": "",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "325047",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "18974",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Call for hours",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "600778",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "18974",
          "service_at_location_id": "",
          "number": "5175418987",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "379981",
          "source_service_id": "18974",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "379982",
          "source_service_id": "18974",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        }
      ],
      "physical_address": [
        {
          "id": "28321",
          "organization_id": "",
          "location_id": "15919",
          "attention": "",
          "address_1": "311 West First Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Charlotte",
          "county": "Eaton",
          "region": "UWJC",
          "state_province": "MI",
          "postal_code": "48813",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "15919",
          "organization_id": "15918",
          "organization_name": "GREAT START - EATON COUNTY",
          "source_id": "78183960",
          "source": "icarol",
          "name": "GREAT START - EATON COUNTY",
          "alternate_name": "",
          "url": "www.eatonresa.org/early-childhood//eaton-great-start",
          "description": "Located on West First Street, between South Clinton Street and South Sheldon Street.",
          "accessibility_for_disabilities": "Accessible Restroom, Accessible Parking, Wheelchair Accessible Service Area, Limited Access",
          "transportation": "No public transportation available",
          "latitude": "42.5518100",
          "longitude": "84.8385600"
        }
      ],
      "service_area_served": [
        {
          "id": "380307",
          "service_id": "",
          "source_service_id": "18974",
          "type": "county",
          "name": "Eaton"
        }
      ]
    },
    {
      "id": 66689,
      "organization_id": 22763,
      "location_id": 22769,
      "source_service_id": 25995,
      "source_id_programAtSite": 78189463,
      "source_id_program": 78163149,
      "source": "icarol",
      "program_id": null,
      "program": null,
      "name": "HOME BASED PARENTING EDUCATION",
      "alternate_name": "PARENTS AS TEACHERS",
      "description": "Provides personalized home visits, by certified parent educators trained in child development, to pregnant people and families with children from birth to kindergarten. Enrollment can occur at any point during this time. Supports parents' understanding of what to expect in each stage of their child's development. Offers practical tips on ways to encourage learning, manage challenging behavior, and promote strong parent-child relationships.  Group meetings are held for parents to gain new insights and to share their experiences, common concerns, and successes.  Offers periodic screening of child's overall development, language, hearing, and vision. Families can receive monthly to twice monthly visits, depending on family needs. Home Visits are generally 60 minutes. Families are also offered 12 group connections per year.",
      "url": "www.zps.org",
      "email": null,
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information.",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals Families with children from birth to kindergarten entry No income guidelines",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information.",
      "service_area": "Greater Zeeland Area",
      "area_served_description": "Greater Zeeland Area",
      "region": "CALL",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "325041",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "25995",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Call for hours.",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "590208",
          "organization_id": "",
          "location_id": "22769",
          "service_id": "",
          "source_service_id": "",
          "service_at_location_id": "",
          "number": "6167483050",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Main Site Phone",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "379961",
          "source_service_id": "25995",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "379962",
          "source_service_id": "25995",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        }
      ],
      "physical_address": [
        {
          "id": "1410",
          "organization_id": "",
          "location_id": "22769",
          "attention": "",
          "address_1": "175 West Roosevelt Avenue",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Zeeland",
          "county": "Ottawa",
          "region": "CALL",
          "state_province": "MI",
          "postal_code": "49464",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "22769",
          "organization_id": "22763",
          "organization_name": "ZEELAND PUBLIC SCHOOLS",
          "source_id": "78188291",
          "source": "icarol",
          "name": "ZEELAND PUBLIC SCHOOLS - ROOSEVELT ELEMENTARY",
          "alternate_name": "ZEELAND PUBLIC SCHOOLS",
          "url": "www.zps.org",
          "description": "Located at the intersection of Felch Street and West Roosevelt Avenue",
          "accessibility_for_disabilities": "Accessible Parking, No Step Entrance, Wheelchair Accessible Service Area",
          "transportation": "No public transportation available",
          "latitude": "42.8197108",
          "longitude": "86.0288673"
        }
      ],
      "service_area_served": [
        {
          "id": "380252",
          "service_id": "",
          "source_service_id": "25995",
          "type": "city",
          "name": "Zeeland-Allegan"
        },
        {
          "id": "380253",
          "service_id": "",
          "source_service_id": "25995",
          "type": "city",
          "name": "Zeeland-Ottawa"
        }
      ]
    },
    {
      "id": 66690,
      "organization_id": 22823,
      "location_id": 22824,
      "source_service_id": 26061,
      "source_id_programAtSite": 78189476,
      "source_id_program": 78163915,
      "source": "icarol",
      "program_id": null,
      "program": "PARENTS AS TEACHERS",
      "name": "HOME BASED PARENTING EDUCATION",
      "alternate_name": "PARENTS AS TEACHERS",
      "description": "Provides personalized home visits, by certified parent educators trained in child development, to pregnant people and families with children from birth to kindergarten. Enrollment can occur at any point during this time. Supports parents' understanding of what to expect in each stage of their child's development. Offers practical tips on ways to encourage learning, manage challenging behavior, and promote strong parent-child relationships.  Group meetings are held for parents to gain new insights and to share their experiences, common concerns, and successes.  Offers periodic screening of child's overall development, language, hearing, and vision. Families can receive monthly to twice monthly visits, depending on family needs. Home Visits are generally 60 minutes. Families are also offered 12 group connections per year.",
      "url": "www.oaisd.org",
      "email": null,
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information.",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals Families with children from birth to kindergarten entry No income guidelines",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information.",
      "service_area": "Ottawa County",
      "area_served_description": "Ottawa County",
      "region": "CALL",
      "contacts": [
        {
          "id": "64174",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "26061",
          "service_at_location_id": "",
          "name": "Maureen Schmidt",
          "title": "Home Visitor Coordinator",
          "department": "",
          "email": "mschmidt@oaisd.org",
          "hasPhone": "0"
        }
      ],
      "regular_schedule": [
        {
          "id": "339228",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "26061",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Call for hours.",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "614978",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "26061",
          "service_at_location_id": "",
          "number": "6167388940",
          "extension": "4664",
          "phone_type_hierarchy": "12",
          "type": "Administrative",
          "department": "",
          "language": "",
          "description": "Home Visitor Coordinator",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "401394",
          "source_service_id": "26061",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "401395",
          "source_service_id": "26061",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        }
      ],
      "physical_address": [
        {
          "id": "1427",
          "organization_id": "",
          "location_id": "22824",
          "attention": "",
          "address_1": "13565 Port Sheldon Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Holland",
          "county": "Ottawa",
          "region": "CALL",
          "state_province": "MI",
          "postal_code": "49424",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "22824",
          "organization_id": "22823",
          "organization_name": "OTTAWA AREA INTERMEDIATE SCHOOL DISTRICT",
          "source_id": "78174442",
          "source": "icarol",
          "name": "OTTAWA AREA INTERMEDIATE SCHOOL DISTRICT",
          "alternate_name": "OAISD",
          "url": "www.oaisd.org",
          "description": "Located directly east of US 31 on Port Sheldon Street",
          "accessibility_for_disabilities": "Wheelchair Accessible Service Area",
          "transportation": "No public transportation available",
          "latitude": "42.8853179",
          "longitude": "86.1134332"
        }
      ],
      "service_area_served": [
        {
          "id": "442811",
          "service_id": "",
          "source_service_id": "26061",
          "type": "county",
          "name": "Ottawa"
        }
      ]
    },
    {
      "id": 66693,
      "organization_id": 24007,
      "location_id": 24010,
      "source_service_id": 27513,
      "source_id_programAtSite": 78189523,
      "source_id_program": 78148239,
      "source": "icarol",
      "program_id": null,
      "program": "PARENTS AS TEACHERS",
      "name": "HOME BASED PARENTING EDUCATION",
      "alternate_name": "PARENTS AS TEACHERS",
      "description": "Provides parent education and family support to families through pregnancy, until the child is five years old. Child care instruction is provided in the home, as well as additional guidance and a parent support group.",
      "url": "www.ncresa.org",
      "email": "lclark@ncresa.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for appointment",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Newaygo County families with a child age 0-5",
      "language": "Spanish and English",
      "payment_accepted": "Not applicable",
      "required_document": "Enrollment forms and application are completed on the first visit to the family's home",
      "service_area": "Newaygo County",
      "area_served_description": "Newaygo County",
      "region": "HWMI",
      "contacts": [
        {
          "id": "60890",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "27513",
          "service_at_location_id": "",
          "name": "Karen Clark",
          "title": "Great Start Collaborative Coordinator",
          "department": "",
          "email": "kclark@ncresa.org",
          "hasPhone": "1"
        }
      ],
      "regular_schedule": [
        {
          "id": "325063",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "27513",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 8am-4pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "600791",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "27513",
          "service_at_location_id": "",
          "number": "2316523604",
          "extension": "",
          "phone_type_hierarchy": "1000",
          "type": "Program Contact",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "380037",
          "source_service_id": "27513",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "380038",
          "source_service_id": "27513",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        }
      ],
      "physical_address": [
        {
          "id": "8729",
          "organization_id": "",
          "location_id": "24010",
          "attention": "",
          "address_1": "585 Fremont Street",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Newaygo",
          "county": "Newaygo",
          "region": "HWMI",
          "state_province": "MI",
          "postal_code": "49337",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "24010",
          "organization_id": "24007",
          "organization_name": "NEWAYGO COUNTY REGIONAL EDUCATIONAL SERVICE AGENCY",
          "source_id": "78178186",
          "source": "icarol",
          "name": "NEWAYGO COUNTY REGIONAL EDUCATIONAL SERVICE  AGENCY  -  NEWAY  CENTER",
          "alternate_name": "NEWAYGO COUNTY REGIONAL EDUCATIONAL SERVICE AGENCY",
          "url": "www.ncresa.org",
          "description": "",
          "accessibility_for_disabilities": "Wheelchair Accessible Service Area, Accessible Parking",
          "transportation": "No public transportation available",
          "latitude": "43.4238396",
          "longitude": "85.8132011"
        }
      ],
      "service_area_served": [
        {
          "id": "380334",
          "service_id": "",
          "source_service_id": "27513",
          "type": "county",
          "name": "Newaygo"
        }
      ]
    },
    {
      "id": 87742,
      "organization_id": 36002,
      "location_id": 36003,
      "source_service_id": 41233,
      "source_id_programAtSite": 78202996,
      "source_id_program": 78171171,
      "source": "icarol",
      "program_id": null,
      "program": null,
      "name": "HOME BASED PARENTING EDUCATION",
      "alternate_name": "PARENTS AS TEACHERS",
      "description": "Provides personalized home visits, by certified parent educators trained in child development, to pregnant people and families with children from birth to kindergarten. Enrollment can occur at any point during this time. Supports parents' understanding of what to expect in each stage of their child's development. Offers practical tips on ways to encourage learning, manage challenging behavior, and promote strong parent-child relationships.  Group meetings are held for parents to gain new insights and to share their experiences, common concerns, and successes.  Offers periodic screening of child's overall development, language, hearing, and vision. Families can receive monthly to twice monthly visits, depending on family needs. Home Visits are generally 60 minutes. Families are also offered 12 group connections per year.",
      "url": "www.oaklandfamilyservices.org",
      "email": "info@ofsfamily.org",
      "status": 1,
      "interpretation_services": null,
      "application_process": "Call for more information",
      "wait_time": null,
      "fees": "No fees",
      "accreditations": null,
      "licenses": null,
      "eligibility": "Pregnant individuals Families with children from birth to kindergarten entry No income guidelines ",
      "language": null,
      "payment_accepted": "Not applicable",
      "required_document": "Call for more information",
      "service_area": "Pontiac",
      "area_served_description": "Pontiac",
      "region": "UWSE",
      "contacts": [],
      "regular_schedule": [
        {
          "id": "340950",
          "organization_id": "",
          "service_id": "",
          "source_service_id": "41233",
          "service_at_location_id": "",
          "weekday": "",
          "opens_at": "",
          "closes_at": "",
          "administrative_hours": "",
          "service_hours": "Mon-Fri 9am-5pm",
          "site_hours": ""
        }
      ],
      "phones": [
        {
          "id": "617343",
          "organization_id": "",
          "location_id": "",
          "service_id": "",
          "source_service_id": "41233",
          "service_at_location_id": "",
          "number": "2488587766",
          "extension": "1209",
          "phone_type_hierarchy": "4",
          "type": "Intake",
          "department": "",
          "language": "",
          "description": "",
          "confidential": "0"
        }
      ],
      "service_taxonomy": [
        {
          "id": "403722",
          "source_service_id": "41233",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Child Care",
          "subcategory": "Parenting Skills"
        },
        {
          "id": "403723",
          "source_service_id": "41233",
          "taxonomy_id": "PH-6100.3300",
          "taxonomy_detail": "Home Based Parenting Education",
          "category": "Education",
          "subcategory": "Parenting Skills"
        }
      ],
      "physical_address": [
        {
          "id": "23519",
          "organization_id": "",
          "location_id": "36003",
          "attention": "",
          "address_1": "114 Orchard Lake Road",
          "address_2": "",
          "address_3": "",
          "address_4": "",
          "city": "Pontiac",
          "county": "Oakland",
          "region": "UWSE",
          "state_province": "MI",
          "postal_code": "48341",
          "country": "United States"
        }
      ],
      "locations": [
        {
          "id": "36003",
          "organization_id": "36002",
          "organization_name": "OAKLAND FAMILY SERVICES",
          "source_id": "78188800",
          "source": "icarol",
          "name": "OAKLAND FAMILY SERVICES",
          "alternate_name": "OFS",
          "url": "www.oaklandfamilyservices.org",
          "description": "Located on the north side of Orchard Lake Road, between Congress and Bagley",
          "accessibility_for_disabilities": "Wheelchair Accessible Service Area",
          "transportation": "No public transportation available",
          "latitude": "42.6351242",
          "longitude": "83.2959010"
        }
      ],
      "service_area_served": [
        {
          "id": "445520",
          "service_id": "",
          "source_service_id": "41233",
          "type": "city",
          "name": "Pontiac"
        }
      ]
    }
  ]
}

const mockSearchResponse = {
  "QueryId": "f18ade72-e569-4d65-9b88-55c8ff8817e2",
  "ResultItems": [
    {
      "Id": "f18ade72-e569-4d65-9b88-55c8ff8817e2-b6b7246e-8009-4154-98ed-bdb0197dc7e1",
      "Type": "ANSWER",
      "AdditionalAttributes": [
        {
          "Key": "AnswerText",
          "ValueType": "TEXT_WITH_HIGHLIGHTS_VALUE",
          "Value": {
            "TextWithHighlightsValue": {
              "Text": "GRACE CHRISTIAN REFORMED CHURCH                             Food Pantries                             \n\tKent, 49503-5203, Grand Rapids \n\t                                                                    \n\n\n                                            \nFOOD PANTRY\n                        \t Offders its food pantry in the parking lot. Lots of fresh produce and meat for guests can choose from. People should arrive between 10am and 10:30am. Doors open at 9:30am for community coffee time. Guests may choose what they want from tables of meat, non-perishables, fresh fruits and vegetables, and bread.\n\n\tContact\twww.gracegr.org\n\tEligibility\tNo restrictions\n\tApplication Process\tNot applicable\n\tDocuments Required\tNot applicable\n\tFees\tNo fees\n\tLocation\t100 Buckley Street SE, Grand Rapids, Kent, MI, 49503-5203,Between Wealthy and Franklin Streets SE, just east of South Division Avenue., Building is fully accessible., Public transportation available\n\tCategory\tFood Pantries\n\tAreas Served\t, , Grand Rapids-Kent\n\tService Hours \tTue 10am-10:30am                            \n\tPhone Number\t(616)-452-8920, (616)-452-8920",
              "Highlights": [
                {
                  "BeginOffset": 60,
                  "EndOffset": 64,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 65,
                  "EndOffset": 73,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 122,
                  "EndOffset": 127,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 128,
                  "EndOffset": 134,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 253,
                  "EndOffset": 257,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 258,
                  "EndOffset": 264,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 303,
                  "EndOffset": 307,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 308,
                  "EndOffset": 314,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 773,
                  "EndOffset": 778,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 779,
                  "EndOffset": 785,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 959,
                  "EndOffset": 963,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 964,
                  "EndOffset": 972,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 991,
                  "EndOffset": 996,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                },
                {
                  "BeginOffset": 997,
                  "EndOffset": 1003,
                  "TopAnswer": false,
                  "Type": "STANDARD"
                }
              ]
            }
          }
        }
      ],
      "DocumentId": "s3://cie-mi211pilotsearch-kendra/services/1758_service.html",
      "DocumentTitle": {
        "Text": "FOOD PANTRY-GRACE CHRISTIAN REFORMED CHURCH-1758",
        "Highlights": [
          {
            "BeginOffset": 0,
            "EndOffset": 4,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 5,
            "EndOffset": 11,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentExcerpt": {
        "Text": "GRACE CHRISTIAN REFORMED CHURCH                             Food Pantries                             \n\tKent, 49503-5203, Grand Rapids \n\t                                                                    \n\n\n                                            \nFOOD PANTRY\n                        \t Offders i",
        "Highlights": [
          {
            "BeginOffset": 0,
            "EndOffset": 300,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentURI": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/1758_service.html",
      "DocumentAttributes": [
        {
          "Key": "_data_source_id",
          "Value": {
            "StringValue": "3c563725-4a80-48c5-b497-6d0d45d30316"
          }
        },
        {
          "Key": "_source_uri",
          "Value": {
            "StringValue": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/1758_service.html"
          }
        }
      ],
      "ScoreAttributes": {
        "ScoreConfidence": "MEDIUM"
      },
      "FeedbackToken": "AYADeCJbzjUjF_0N9tgD9KvVGPwAXwABABVhd3MtY3J5cHRvLXB1YmxpYy1rZXkAREF2MG1pWDB2VG9jbWRnZndSUXJqQ2lrL2hoRURzNHdXemJiOUkvWjJ0a0JmNjJSSVJZbklibTV0U2crekk3Zm94dz09AAEAB2F3cy1rbXMAS2Fybjphd3M6a21zOnVzLWVhc3QtMTo3OTQyODk5MjcwNzA6a2V5LzA4YjVkYTRmLWQyOWEtNDU3Mi04OTAwLTRkZjMzN2VjYzljYwC4AQIBAHj0zQzhkrLuQ7zD8HaKUpTKx0B1ZhTxova5poogpTSq9gFY_kCqy-4CRV-fBhH2hsWiAAAAfjB8BgkqhkiG9w0BBwagbzBtAgEAMGgGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMVyjzzVphIjHqA3Q5AgEQgDuqnglgXCO0uUGeSXdKd03Zj-2ogyJlKwjcl_Pr6MHI9jOug5mtuzCx8v0iJOAcigkoPT9qJ5P2M_eKwwIAAAAADAAAEAAAAAAAAAAAAAAAAABnxJg3Ru7KwgJ9BWT-NldI_____wAAAAEAAAAAAAAAAAAAAAEAAAF2RG3ZtGeV0rlFH_Ex1Iii1H66uwaihAiqCs7RZVsA7o_DXsduGPLQEpg6OvzkUH8xWu8OmfrLiNOH7tDDt_GBFRSVrsZOJdUAcUtICj1J2rrjPlulJNNhHz_jNgLg0OBKjqxSTfAaHh0f3d69Y0Td3iaRLNFtVyyC-A5TBY4SDWmi_G0TXsHGlzMWvSYVPVNbO-OApxBVxz3xTaJCjxfsoP_UoXh75ZQKt37jPpz3se9pf3aYh4qiBJ7kGhvHmunAM63cu02FuOLGd6ddF6AFuBcRqsq3sRNFzInmaqYJ8QIZlNANDiZZYgMyIm6aXIAMzOdmUhic84WuamtUzwTkL6DPbL8TC4jtuwhzFuVoiRlx33y9m73qFkXpltQgIlhDH1W6eRZHo2zFw7oN7EpDt2Ptw3A64G2pmemCVo4TTzI_EOcM27ZD3NWVSZSZKgfnszBX6GYYxaPGJwgtkrAEEiG5fQtgbCPWKaD58JrT8xPi-6kCKxs9gttff11hDpL0pZE8JaIdAGcwZQIwYYEIGuY6NroB8YvBGRueqEbx7DVQeBLwFeWCmHN8muQSzwiftrfGwgfXBHTyM-dtAjEA3LGtPAzOSIDSjNgybqMM6uQON3U8278vDMPwuk8K4aFpp6Gzd3pmhVOySUmqkEZ7.f18ade72-e569-4d65-9b88-55c8ff8817e2-b6b7246e-8009-4154-98ed-bdb0197dc7e1"
    },
    {
      "Id": "f18ade72-e569-4d65-9b88-55c8ff8817e2-6a28d4bc-7383-4407-9485-83b17afd2264",
      "Type": "DOCUMENT",
      "AdditionalAttributes": [],
      "DocumentId": "s3://cie-mi211pilotsearch-kendra/services/1704_service.html",
      "DocumentTitle": {
        "Text": "FOOD PANTRY-SECOM RESOURCE CENTER-1704",
        "Highlights": [
          {
            "BeginOffset": 0,
            "EndOffset": 4,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 5,
            "EndOffset": 11,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentExcerpt": {
        "Text": "...Food Production/Preparation/Delivery Volunteer Opportunities                             \n\tKent, 49507, Grand Rapids \n\t                                                                    \n\n\n                                            \nFOOD PANTRY\n                        \t Provides food...",
        "Highlights": [
          {
            "BeginOffset": 3,
            "EndOffset": 7,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 107,
            "EndOffset": 112,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 113,
            "EndOffset": 119,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 238,
            "EndOffset": 242,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 243,
            "EndOffset": 249,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 285,
            "EndOffset": 289,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentURI": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/1704_service.html",
      "DocumentAttributes": [
        {
          "Key": "_data_source_id",
          "Value": {
            "StringValue": "3c563725-4a80-48c5-b497-6d0d45d30316"
          }
        },
        {
          "Key": "_source_uri",
          "Value": {
            "StringValue": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/1704_service.html"
          }
        }
      ],
      "ScoreAttributes": {
        "ScoreConfidence": "VERY_HIGH"
      },
      "FeedbackToken": "AYADeCJbzjUjF_0N9tgD9KvVGPwAXwABABVhd3MtY3J5cHRvLXB1YmxpYy1rZXkAREF2MG1pWDB2VG9jbWRnZndSUXJqQ2lrL2hoRURzNHdXemJiOUkvWjJ0a0JmNjJSSVJZbklibTV0U2crekk3Zm94dz09AAEAB2F3cy1rbXMAS2Fybjphd3M6a21zOnVzLWVhc3QtMTo3OTQyODk5MjcwNzA6a2V5LzA4YjVkYTRmLWQyOWEtNDU3Mi04OTAwLTRkZjMzN2VjYzljYwC4AQIBAHj0zQzhkrLuQ7zD8HaKUpTKx0B1ZhTxova5poogpTSq9gFY_kCqy-4CRV-fBhH2hsWiAAAAfjB8BgkqhkiG9w0BBwagbzBtAgEAMGgGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMVyjzzVphIjHqA3Q5AgEQgDuqnglgXCO0uUGeSXdKd03Zj-2ogyJlKwjcl_Pr6MHI9jOug5mtuzCx8v0iJOAcigkoPT9qJ5P2M_eKwwIAAAAADAAAEAAAAAAAAAAAAAAAAABnxJg3Ru7KwgJ9BWT-NldI_____wAAAAEAAAAAAAAAAAAAAAEAAAF2RG3ZtGeV0rlFH_Ex1Iii1H66uwaihAiqCs7RZVsA7o_DXsduGPLQEpg6OvzkUH8xWu8OmfrLiNOH7tDDt_GBFRSVrsZOJdUAcUtICj1J2rrjPlulJNNhHz_jNgLg0OBKjqxSTfAaHh0f3d69Y0Td3iaRLNFtVyyC-A5TBY4SDWmi_G0TXsHGlzMWvSYVPVNbO-OApxBVxz3xTaJCjxfsoP_UoXh75ZQKt37jPpz3se9pf3aYh4qiBJ7kGhvHmunAM63cu02FuOLGd6ddF6AFuBcRqsq3sRNFzInmaqYJ8QIZlNANDiZZYgMyIm6aXIAMzOdmUhic84WuamtUzwTkL6DPbL8TC4jtuwhzFuVoiRlx33y9m73qFkXpltQgIlhDH1W6eRZHo2zFw7oN7EpDt2Ptw3A64G2pmemCVo4TTzI_EOcM27ZD3NWVSZSZKgfnszBX6GYYxaPGJwgtkrAEEiG5fQtgbCPWKaD58JrT8xPi-6kCKxs9gttff11hDpL0pZE8JaIdAGcwZQIwYYEIGuY6NroB8YvBGRueqEbx7DVQeBLwFeWCmHN8muQSzwiftrfGwgfXBHTyM-dtAjEA3LGtPAzOSIDSjNgybqMM6uQON3U8278vDMPwuk8K4aFpp6Gzd3pmhVOySUmqkEZ7.f18ade72-e569-4d65-9b88-55c8ff8817e2-6a28d4bc-7383-4407-9485-83b17afd2264"
    },
    {
      "Id": "f18ade72-e569-4d65-9b88-55c8ff8817e2-e8bbe01d-fa05-4af4-b0cc-937a405ca068",
      "Type": "DOCUMENT",
      "AdditionalAttributes": [],
      "DocumentId": "s3://cie-mi211pilotsearch-kendra/services/1758_service.html",
      "DocumentTitle": {
        "Text": "FOOD PANTRY-GRACE CHRISTIAN REFORMED CHURCH-1758",
        "Highlights": [
          {
            "BeginOffset": 0,
            "EndOffset": 4,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 5,
            "EndOffset": 11,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentExcerpt": {
        "Text": "...Food Pantries                             \n\tKent, 49503-5203, Grand Rapids \n\t                                                                    \n\n\n                                            \nFOOD PANTRY\n                        \t Offders its food pantry in the parking lot...",
        "Highlights": [
          {
            "BeginOffset": 3,
            "EndOffset": 7,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 8,
            "EndOffset": 16,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 65,
            "EndOffset": 70,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 71,
            "EndOffset": 77,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 196,
            "EndOffset": 200,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 201,
            "EndOffset": 207,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 246,
            "EndOffset": 250,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 251,
            "EndOffset": 257,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentURI": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/1758_service.html",
      "DocumentAttributes": [
        {
          "Key": "_data_source_id",
          "Value": {
            "StringValue": "3c563725-4a80-48c5-b497-6d0d45d30316"
          }
        },
        {
          "Key": "_source_uri",
          "Value": {
            "StringValue": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/1758_service.html"
          }
        }
      ],
      "ScoreAttributes": {
        "ScoreConfidence": "HIGH"
      },
      "FeedbackToken": "AYADeCJbzjUjF_0N9tgD9KvVGPwAXwABABVhd3MtY3J5cHRvLXB1YmxpYy1rZXkAREF2MG1pWDB2VG9jbWRnZndSUXJqQ2lrL2hoRURzNHdXemJiOUkvWjJ0a0JmNjJSSVJZbklibTV0U2crekk3Zm94dz09AAEAB2F3cy1rbXMAS2Fybjphd3M6a21zOnVzLWVhc3QtMTo3OTQyODk5MjcwNzA6a2V5LzA4YjVkYTRmLWQyOWEtNDU3Mi04OTAwLTRkZjMzN2VjYzljYwC4AQIBAHj0zQzhkrLuQ7zD8HaKUpTKx0B1ZhTxova5poogpTSq9gFY_kCqy-4CRV-fBhH2hsWiAAAAfjB8BgkqhkiG9w0BBwagbzBtAgEAMGgGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMVyjzzVphIjHqA3Q5AgEQgDuqnglgXCO0uUGeSXdKd03Zj-2ogyJlKwjcl_Pr6MHI9jOug5mtuzCx8v0iJOAcigkoPT9qJ5P2M_eKwwIAAAAADAAAEAAAAAAAAAAAAAAAAABnxJg3Ru7KwgJ9BWT-NldI_____wAAAAEAAAAAAAAAAAAAAAEAAAF2RG3ZtGeV0rlFH_Ex1Iii1H66uwaihAiqCs7RZVsA7o_DXsduGPLQEpg6OvzkUH8xWu8OmfrLiNOH7tDDt_GBFRSVrsZOJdUAcUtICj1J2rrjPlulJNNhHz_jNgLg0OBKjqxSTfAaHh0f3d69Y0Td3iaRLNFtVyyC-A5TBY4SDWmi_G0TXsHGlzMWvSYVPVNbO-OApxBVxz3xTaJCjxfsoP_UoXh75ZQKt37jPpz3se9pf3aYh4qiBJ7kGhvHmunAM63cu02FuOLGd6ddF6AFuBcRqsq3sRNFzInmaqYJ8QIZlNANDiZZYgMyIm6aXIAMzOdmUhic84WuamtUzwTkL6DPbL8TC4jtuwhzFuVoiRlx33y9m73qFkXpltQgIlhDH1W6eRZHo2zFw7oN7EpDt2Ptw3A64G2pmemCVo4TTzI_EOcM27ZD3NWVSZSZKgfnszBX6GYYxaPGJwgtkrAEEiG5fQtgbCPWKaD58JrT8xPi-6kCKxs9gttff11hDpL0pZE8JaIdAGcwZQIwYYEIGuY6NroB8YvBGRueqEbx7DVQeBLwFeWCmHN8muQSzwiftrfGwgfXBHTyM-dtAjEA3LGtPAzOSIDSjNgybqMM6uQON3U8278vDMPwuk8K4aFpp6Gzd3pmhVOySUmqkEZ7.f18ade72-e569-4d65-9b88-55c8ff8817e2-e8bbe01d-fa05-4af4-b0cc-937a405ca068"
    },
    {
      "Id": "f18ade72-e569-4d65-9b88-55c8ff8817e2-b41e853d-8c5b-4b3a-b718-87a12965315e",
      "Type": "DOCUMENT",
      "AdditionalAttributes": [],
      "DocumentId": "s3://cie-mi211pilotsearch-kendra/services/5984_service.html",
      "DocumentTitle": {
        "Text": "FOOD PANTRY-CITY OF PENTECOST CHURCH-5984",
        "Highlights": [
          {
            "BeginOffset": 0,
            "EndOffset": 4,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 5,
            "EndOffset": 11,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentExcerpt": {
        "Text": "...Food Pantries                             \n\tKent, 49505, Grand Rapids \n\t                                                                    \n\n\n                                            \nFOOD PANTRY\n                        \t Provides a general food pantry for Grand Rapids residents...",
        "Highlights": [
          {
            "BeginOffset": 3,
            "EndOffset": 7,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 8,
            "EndOffset": 16,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 60,
            "EndOffset": 65,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 66,
            "EndOffset": 72,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 191,
            "EndOffset": 195,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 196,
            "EndOffset": 202,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 248,
            "EndOffset": 252,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 253,
            "EndOffset": 259,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 264,
            "EndOffset": 269,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 270,
            "EndOffset": 276,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentURI": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/5984_service.html",
      "DocumentAttributes": [
        {
          "Key": "_data_source_id",
          "Value": {
            "StringValue": "3c563725-4a80-48c5-b497-6d0d45d30316"
          }
        },
        {
          "Key": "_source_uri",
          "Value": {
            "StringValue": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/5984_service.html"
          }
        }
      ],
      "ScoreAttributes": {
        "ScoreConfidence": "HIGH"
      },
      "FeedbackToken": "AYADeCJbzjUjF_0N9tgD9KvVGPwAXwABABVhd3MtY3J5cHRvLXB1YmxpYy1rZXkAREF2MG1pWDB2VG9jbWRnZndSUXJqQ2lrL2hoRURzNHdXemJiOUkvWjJ0a0JmNjJSSVJZbklibTV0U2crekk3Zm94dz09AAEAB2F3cy1rbXMAS2Fybjphd3M6a21zOnVzLWVhc3QtMTo3OTQyODk5MjcwNzA6a2V5LzA4YjVkYTRmLWQyOWEtNDU3Mi04OTAwLTRkZjMzN2VjYzljYwC4AQIBAHj0zQzhkrLuQ7zD8HaKUpTKx0B1ZhTxova5poogpTSq9gFY_kCqy-4CRV-fBhH2hsWiAAAAfjB8BgkqhkiG9w0BBwagbzBtAgEAMGgGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMVyjzzVphIjHqA3Q5AgEQgDuqnglgXCO0uUGeSXdKd03Zj-2ogyJlKwjcl_Pr6MHI9jOug5mtuzCx8v0iJOAcigkoPT9qJ5P2M_eKwwIAAAAADAAAEAAAAAAAAAAAAAAAAABnxJg3Ru7KwgJ9BWT-NldI_____wAAAAEAAAAAAAAAAAAAAAEAAAF2RG3ZtGeV0rlFH_Ex1Iii1H66uwaihAiqCs7RZVsA7o_DXsduGPLQEpg6OvzkUH8xWu8OmfrLiNOH7tDDt_GBFRSVrsZOJdUAcUtICj1J2rrjPlulJNNhHz_jNgLg0OBKjqxSTfAaHh0f3d69Y0Td3iaRLNFtVyyC-A5TBY4SDWmi_G0TXsHGlzMWvSYVPVNbO-OApxBVxz3xTaJCjxfsoP_UoXh75ZQKt37jPpz3se9pf3aYh4qiBJ7kGhvHmunAM63cu02FuOLGd6ddF6AFuBcRqsq3sRNFzInmaqYJ8QIZlNANDiZZYgMyIm6aXIAMzOdmUhic84WuamtUzwTkL6DPbL8TC4jtuwhzFuVoiRlx33y9m73qFkXpltQgIlhDH1W6eRZHo2zFw7oN7EpDt2Ptw3A64G2pmemCVo4TTzI_EOcM27ZD3NWVSZSZKgfnszBX6GYYxaPGJwgtkrAEEiG5fQtgbCPWKaD58JrT8xPi-6kCKxs9gttff11hDpL0pZE8JaIdAGcwZQIwYYEIGuY6NroB8YvBGRueqEbx7DVQeBLwFeWCmHN8muQSzwiftrfGwgfXBHTyM-dtAjEA3LGtPAzOSIDSjNgybqMM6uQON3U8278vDMPwuk8K4aFpp6Gzd3pmhVOySUmqkEZ7.f18ade72-e569-4d65-9b88-55c8ff8817e2-b41e853d-8c5b-4b3a-b718-87a12965315e"
    },
    {
      "Id": "f18ade72-e569-4d65-9b88-55c8ff8817e2-d76b4141-4d91-4f6a-8420-c69933f3789e",
      "Type": "DOCUMENT",
      "AdditionalAttributes": [],
      "DocumentId": "s3://cie-mi211pilotsearch-kendra/services/5985_service.html",
      "DocumentTitle": {
        "Text": "FOOD PANTRY-CITY OF PENTECOST CHURCH-5985",
        "Highlights": [
          {
            "BeginOffset": 0,
            "EndOffset": 4,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 5,
            "EndOffset": 11,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentExcerpt": {
        "Text": "...CHURCH                             Food Pantries, Special Diet Food                             \n\tKent, 49505, Grand Rapids \n\t                                                                    \n\n\n                                            \nFOOD PANTRY\n                        \t Offers renal...",
        "Highlights": [
          {
            "BeginOffset": 38,
            "EndOffset": 42,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 43,
            "EndOffset": 51,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 66,
            "EndOffset": 70,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 114,
            "EndOffset": 119,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 120,
            "EndOffset": 126,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 245,
            "EndOffset": 249,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 250,
            "EndOffset": 256,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentURI": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/5985_service.html",
      "DocumentAttributes": [
        {
          "Key": "_data_source_id",
          "Value": {
            "StringValue": "3c563725-4a80-48c5-b497-6d0d45d30316"
          }
        },
        {
          "Key": "_source_uri",
          "Value": {
            "StringValue": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/5985_service.html"
          }
        }
      ],
      "ScoreAttributes": {
        "ScoreConfidence": "HIGH"
      },
      "FeedbackToken": "AYADeCJbzjUjF_0N9tgD9KvVGPwAXwABABVhd3MtY3J5cHRvLXB1YmxpYy1rZXkAREF2MG1pWDB2VG9jbWRnZndSUXJqQ2lrL2hoRURzNHdXemJiOUkvWjJ0a0JmNjJSSVJZbklibTV0U2crekk3Zm94dz09AAEAB2F3cy1rbXMAS2Fybjphd3M6a21zOnVzLWVhc3QtMTo3OTQyODk5MjcwNzA6a2V5LzA4YjVkYTRmLWQyOWEtNDU3Mi04OTAwLTRkZjMzN2VjYzljYwC4AQIBAHj0zQzhkrLuQ7zD8HaKUpTKx0B1ZhTxova5poogpTSq9gFY_kCqy-4CRV-fBhH2hsWiAAAAfjB8BgkqhkiG9w0BBwagbzBtAgEAMGgGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMVyjzzVphIjHqA3Q5AgEQgDuqnglgXCO0uUGeSXdKd03Zj-2ogyJlKwjcl_Pr6MHI9jOug5mtuzCx8v0iJOAcigkoPT9qJ5P2M_eKwwIAAAAADAAAEAAAAAAAAAAAAAAAAABnxJg3Ru7KwgJ9BWT-NldI_____wAAAAEAAAAAAAAAAAAAAAEAAAF2RG3ZtGeV0rlFH_Ex1Iii1H66uwaihAiqCs7RZVsA7o_DXsduGPLQEpg6OvzkUH8xWu8OmfrLiNOH7tDDt_GBFRSVrsZOJdUAcUtICj1J2rrjPlulJNNhHz_jNgLg0OBKjqxSTfAaHh0f3d69Y0Td3iaRLNFtVyyC-A5TBY4SDWmi_G0TXsHGlzMWvSYVPVNbO-OApxBVxz3xTaJCjxfsoP_UoXh75ZQKt37jPpz3se9pf3aYh4qiBJ7kGhvHmunAM63cu02FuOLGd6ddF6AFuBcRqsq3sRNFzInmaqYJ8QIZlNANDiZZYgMyIm6aXIAMzOdmUhic84WuamtUzwTkL6DPbL8TC4jtuwhzFuVoiRlx33y9m73qFkXpltQgIlhDH1W6eRZHo2zFw7oN7EpDt2Ptw3A64G2pmemCVo4TTzI_EOcM27ZD3NWVSZSZKgfnszBX6GYYxaPGJwgtkrAEEiG5fQtgbCPWKaD58JrT8xPi-6kCKxs9gttff11hDpL0pZE8JaIdAGcwZQIwYYEIGuY6NroB8YvBGRueqEbx7DVQeBLwFeWCmHN8muQSzwiftrfGwgfXBHTyM-dtAjEA3LGtPAzOSIDSjNgybqMM6uQON3U8278vDMPwuk8K4aFpp6Gzd3pmhVOySUmqkEZ7.f18ade72-e569-4d65-9b88-55c8ff8817e2-d76b4141-4d91-4f6a-8420-c69933f3789e"
    },
    {
      "Id": "f18ade72-e569-4d65-9b88-55c8ff8817e2-bf0ce1fd-9ace-4faa-8143-ebed857ea3e9",
      "Type": "DOCUMENT",
      "AdditionalAttributes": [],
      "DocumentId": "s3://cie-mi211pilotsearch-kendra/services/150793_service.html",
      "DocumentTitle": {
        "Text": "FOOD PANTRIES-SALVATION ARMY (THE), GRAND VALLEY AREA COMMAND-150793",
        "Highlights": [
          {
            "BeginOffset": 0,
            "EndOffset": 4,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 36,
            "EndOffset": 41,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentExcerpt": {
        "Text": "...SALVATION ARMY (THE), GRAND VALLEY AREA COMMAND                             Food Pantries                             \n\tKent, 49503, Grand Rapids \n\t                                                                    \n\n\n                                            \nFOOD PANTRIES...",
        "Highlights": [
          {
            "BeginOffset": 25,
            "EndOffset": 30,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 79,
            "EndOffset": 83,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 84,
            "EndOffset": 92,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 136,
            "EndOffset": 141,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 142,
            "EndOffset": 148,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 267,
            "EndOffset": 271,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 272,
            "EndOffset": 280,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentURI": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/150793_service.html",
      "DocumentAttributes": [
        {
          "Key": "_data_source_id",
          "Value": {
            "StringValue": "3c563725-4a80-48c5-b497-6d0d45d30316"
          }
        },
        {
          "Key": "_source_uri",
          "Value": {
            "StringValue": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/150793_service.html"
          }
        }
      ],
      "ScoreAttributes": {
        "ScoreConfidence": "HIGH"
      },
      "FeedbackToken": "AYADeCJbzjUjF_0N9tgD9KvVGPwAXwABABVhd3MtY3J5cHRvLXB1YmxpYy1rZXkAREF2MG1pWDB2VG9jbWRnZndSUXJqQ2lrL2hoRURzNHdXemJiOUkvWjJ0a0JmNjJSSVJZbklibTV0U2crekk3Zm94dz09AAEAB2F3cy1rbXMAS2Fybjphd3M6a21zOnVzLWVhc3QtMTo3OTQyODk5MjcwNzA6a2V5LzA4YjVkYTRmLWQyOWEtNDU3Mi04OTAwLTRkZjMzN2VjYzljYwC4AQIBAHj0zQzhkrLuQ7zD8HaKUpTKx0B1ZhTxova5poogpTSq9gFY_kCqy-4CRV-fBhH2hsWiAAAAfjB8BgkqhkiG9w0BBwagbzBtAgEAMGgGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMVyjzzVphIjHqA3Q5AgEQgDuqnglgXCO0uUGeSXdKd03Zj-2ogyJlKwjcl_Pr6MHI9jOug5mtuzCx8v0iJOAcigkoPT9qJ5P2M_eKwwIAAAAADAAAEAAAAAAAAAAAAAAAAABnxJg3Ru7KwgJ9BWT-NldI_____wAAAAEAAAAAAAAAAAAAAAEAAAF2RG3ZtGeV0rlFH_Ex1Iii1H66uwaihAiqCs7RZVsA7o_DXsduGPLQEpg6OvzkUH8xWu8OmfrLiNOH7tDDt_GBFRSVrsZOJdUAcUtICj1J2rrjPlulJNNhHz_jNgLg0OBKjqxSTfAaHh0f3d69Y0Td3iaRLNFtVyyC-A5TBY4SDWmi_G0TXsHGlzMWvSYVPVNbO-OApxBVxz3xTaJCjxfsoP_UoXh75ZQKt37jPpz3se9pf3aYh4qiBJ7kGhvHmunAM63cu02FuOLGd6ddF6AFuBcRqsq3sRNFzInmaqYJ8QIZlNANDiZZYgMyIm6aXIAMzOdmUhic84WuamtUzwTkL6DPbL8TC4jtuwhzFuVoiRlx33y9m73qFkXpltQgIlhDH1W6eRZHo2zFw7oN7EpDt2Ptw3A64G2pmemCVo4TTzI_EOcM27ZD3NWVSZSZKgfnszBX6GYYxaPGJwgtkrAEEiG5fQtgbCPWKaD58JrT8xPi-6kCKxs9gttff11hDpL0pZE8JaIdAGcwZQIwYYEIGuY6NroB8YvBGRueqEbx7DVQeBLwFeWCmHN8muQSzwiftrfGwgfXBHTyM-dtAjEA3LGtPAzOSIDSjNgybqMM6uQON3U8278vDMPwuk8K4aFpp6Gzd3pmhVOySUmqkEZ7.f18ade72-e569-4d65-9b88-55c8ff8817e2-bf0ce1fd-9ace-4faa-8143-ebed857ea3e9"
    },
    {
      "Id": "f18ade72-e569-4d65-9b88-55c8ff8817e2-bfc90bce-7628-4364-be55-da006bfa9032",
      "Type": "DOCUMENT",
      "AdditionalAttributes": [],
      "DocumentId": "s3://cie-mi211pilotsearch-kendra/services/111226_service.html",
      "DocumentTitle": {
        "Text": "FOOD PANTRIES-ACTS GOSPEL MINISTRY-111226",
        "Highlights": [
          {
            "BeginOffset": 0,
            "EndOffset": 4,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentExcerpt": {
        "Text": "...Food Pantries                             \n\tKent, 49504, Grand Rapids \n\t                                                                    \n\n\n                                            \nFOOD PANTRIES\n                        \t Provides a food pantry and emergency food...",
        "Highlights": [
          {
            "BeginOffset": 3,
            "EndOffset": 7,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 8,
            "EndOffset": 16,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 60,
            "EndOffset": 65,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 66,
            "EndOffset": 72,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 191,
            "EndOffset": 195,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 196,
            "EndOffset": 204,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 242,
            "EndOffset": 246,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 247,
            "EndOffset": 253,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 268,
            "EndOffset": 272,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentURI": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/111226_service.html",
      "DocumentAttributes": [
        {
          "Key": "_data_source_id",
          "Value": {
            "StringValue": "3c563725-4a80-48c5-b497-6d0d45d30316"
          }
        },
        {
          "Key": "_source_uri",
          "Value": {
            "StringValue": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/111226_service.html"
          }
        }
      ],
      "ScoreAttributes": {
        "ScoreConfidence": "HIGH"
      },
      "FeedbackToken": "AYADeCJbzjUjF_0N9tgD9KvVGPwAXwABABVhd3MtY3J5cHRvLXB1YmxpYy1rZXkAREF2MG1pWDB2VG9jbWRnZndSUXJqQ2lrL2hoRURzNHdXemJiOUkvWjJ0a0JmNjJSSVJZbklibTV0U2crekk3Zm94dz09AAEAB2F3cy1rbXMAS2Fybjphd3M6a21zOnVzLWVhc3QtMTo3OTQyODk5MjcwNzA6a2V5LzA4YjVkYTRmLWQyOWEtNDU3Mi04OTAwLTRkZjMzN2VjYzljYwC4AQIBAHj0zQzhkrLuQ7zD8HaKUpTKx0B1ZhTxova5poogpTSq9gFY_kCqy-4CRV-fBhH2hsWiAAAAfjB8BgkqhkiG9w0BBwagbzBtAgEAMGgGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMVyjzzVphIjHqA3Q5AgEQgDuqnglgXCO0uUGeSXdKd03Zj-2ogyJlKwjcl_Pr6MHI9jOug5mtuzCx8v0iJOAcigkoPT9qJ5P2M_eKwwIAAAAADAAAEAAAAAAAAAAAAAAAAABnxJg3Ru7KwgJ9BWT-NldI_____wAAAAEAAAAAAAAAAAAAAAEAAAF2RG3ZtGeV0rlFH_Ex1Iii1H66uwaihAiqCs7RZVsA7o_DXsduGPLQEpg6OvzkUH8xWu8OmfrLiNOH7tDDt_GBFRSVrsZOJdUAcUtICj1J2rrjPlulJNNhHz_jNgLg0OBKjqxSTfAaHh0f3d69Y0Td3iaRLNFtVyyC-A5TBY4SDWmi_G0TXsHGlzMWvSYVPVNbO-OApxBVxz3xTaJCjxfsoP_UoXh75ZQKt37jPpz3se9pf3aYh4qiBJ7kGhvHmunAM63cu02FuOLGd6ddF6AFuBcRqsq3sRNFzInmaqYJ8QIZlNANDiZZYgMyIm6aXIAMzOdmUhic84WuamtUzwTkL6DPbL8TC4jtuwhzFuVoiRlx33y9m73qFkXpltQgIlhDH1W6eRZHo2zFw7oN7EpDt2Ptw3A64G2pmemCVo4TTzI_EOcM27ZD3NWVSZSZKgfnszBX6GYYxaPGJwgtkrAEEiG5fQtgbCPWKaD58JrT8xPi-6kCKxs9gttff11hDpL0pZE8JaIdAGcwZQIwYYEIGuY6NroB8YvBGRueqEbx7DVQeBLwFeWCmHN8muQSzwiftrfGwgfXBHTyM-dtAjEA3LGtPAzOSIDSjNgybqMM6uQON3U8278vDMPwuk8K4aFpp6Gzd3pmhVOySUmqkEZ7.f18ade72-e569-4d65-9b88-55c8ff8817e2-bfc90bce-7628-4364-be55-da006bfa9032"
    },
    {
      "Id": "f18ade72-e569-4d65-9b88-55c8ff8817e2-426dd25b-7250-4d74-a8c4-ea24e2563b5f",
      "Type": "DOCUMENT",
      "AdditionalAttributes": [],
      "DocumentId": "s3://cie-mi211pilotsearch-kendra/services/169902_service.html",
      "DocumentTitle": {
        "Text": "FOOD PANTRIES-FULLER AVENUE CHRISTIAN REFORMED CHURCH-169902",
        "Highlights": [
          {
            "BeginOffset": 0,
            "EndOffset": 4,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentExcerpt": {
        "Text": "...Food Pantries                             \n\tKent, 49506, Grand Rapids \n\t                                                                    \n\n\n                                            \nFOOD PANTRIES\n                        \t Provides free food for people in need...",
        "Highlights": [
          {
            "BeginOffset": 3,
            "EndOffset": 7,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 8,
            "EndOffset": 16,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 60,
            "EndOffset": 65,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 66,
            "EndOffset": 72,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 191,
            "EndOffset": 195,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 196,
            "EndOffset": 204,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 245,
            "EndOffset": 249,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentURI": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/169902_service.html",
      "DocumentAttributes": [
        {
          "Key": "_data_source_id",
          "Value": {
            "StringValue": "3c563725-4a80-48c5-b497-6d0d45d30316"
          }
        },
        {
          "Key": "_source_uri",
          "Value": {
            "StringValue": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/169902_service.html"
          }
        }
      ],
      "ScoreAttributes": {
        "ScoreConfidence": "HIGH"
      },
      "FeedbackToken": "AYADeCJbzjUjF_0N9tgD9KvVGPwAXwABABVhd3MtY3J5cHRvLXB1YmxpYy1rZXkAREF2MG1pWDB2VG9jbWRnZndSUXJqQ2lrL2hoRURzNHdXemJiOUkvWjJ0a0JmNjJSSVJZbklibTV0U2crekk3Zm94dz09AAEAB2F3cy1rbXMAS2Fybjphd3M6a21zOnVzLWVhc3QtMTo3OTQyODk5MjcwNzA6a2V5LzA4YjVkYTRmLWQyOWEtNDU3Mi04OTAwLTRkZjMzN2VjYzljYwC4AQIBAHj0zQzhkrLuQ7zD8HaKUpTKx0B1ZhTxova5poogpTSq9gFY_kCqy-4CRV-fBhH2hsWiAAAAfjB8BgkqhkiG9w0BBwagbzBtAgEAMGgGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMVyjzzVphIjHqA3Q5AgEQgDuqnglgXCO0uUGeSXdKd03Zj-2ogyJlKwjcl_Pr6MHI9jOug5mtuzCx8v0iJOAcigkoPT9qJ5P2M_eKwwIAAAAADAAAEAAAAAAAAAAAAAAAAABnxJg3Ru7KwgJ9BWT-NldI_____wAAAAEAAAAAAAAAAAAAAAEAAAF2RG3ZtGeV0rlFH_Ex1Iii1H66uwaihAiqCs7RZVsA7o_DXsduGPLQEpg6OvzkUH8xWu8OmfrLiNOH7tDDt_GBFRSVrsZOJdUAcUtICj1J2rrjPlulJNNhHz_jNgLg0OBKjqxSTfAaHh0f3d69Y0Td3iaRLNFtVyyC-A5TBY4SDWmi_G0TXsHGlzMWvSYVPVNbO-OApxBVxz3xTaJCjxfsoP_UoXh75ZQKt37jPpz3se9pf3aYh4qiBJ7kGhvHmunAM63cu02FuOLGd6ddF6AFuBcRqsq3sRNFzInmaqYJ8QIZlNANDiZZYgMyIm6aXIAMzOdmUhic84WuamtUzwTkL6DPbL8TC4jtuwhzFuVoiRlx33y9m73qFkXpltQgIlhDH1W6eRZHo2zFw7oN7EpDt2Ptw3A64G2pmemCVo4TTzI_EOcM27ZD3NWVSZSZKgfnszBX6GYYxaPGJwgtkrAEEiG5fQtgbCPWKaD58JrT8xPi-6kCKxs9gttff11hDpL0pZE8JaIdAGcwZQIwYYEIGuY6NroB8YvBGRueqEbx7DVQeBLwFeWCmHN8muQSzwiftrfGwgfXBHTyM-dtAjEA3LGtPAzOSIDSjNgybqMM6uQON3U8278vDMPwuk8K4aFpp6Gzd3pmhVOySUmqkEZ7.f18ade72-e569-4d65-9b88-55c8ff8817e2-426dd25b-7250-4d74-a8c4-ea24e2563b5f"
    },
    {
      "Id": "f18ade72-e569-4d65-9b88-55c8ff8817e2-fbef050a-ba5a-4e53-9f4f-20d84c4d9da7",
      "Type": "DOCUMENT",
      "AdditionalAttributes": [],
      "DocumentId": "s3://cie-mi211pilotsearch-kendra/services/123001_service.html",
      "DocumentTitle": {
        "Text": "SPECIAL DIET FOOD PANTRY-NORTH END COMMUNITY MINISTRY-123001",
        "Highlights": [
          {
            "BeginOffset": 13,
            "EndOffset": 17,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 18,
            "EndOffset": 24,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentExcerpt": {
        "Text": "...Kent, 49505, Grand Rapids \n\t                                                                    \n\n\n                                            \nSPECIAL DIET FOOD PANTRY\n                        \t Provides a Special Dietary Food Pantry providing foods to assist Diabetics in managing...",
        "Highlights": [
          {
            "BeginOffset": 16,
            "EndOffset": 21,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 22,
            "EndOffset": 28,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 160,
            "EndOffset": 164,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 165,
            "EndOffset": 171,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 225,
            "EndOffset": 229,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 230,
            "EndOffset": 236,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 247,
            "EndOffset": 252,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentURI": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/123001_service.html",
      "DocumentAttributes": [
        {
          "Key": "_data_source_id",
          "Value": {
            "StringValue": "3c563725-4a80-48c5-b497-6d0d45d30316"
          }
        },
        {
          "Key": "_source_uri",
          "Value": {
            "StringValue": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/123001_service.html"
          }
        }
      ],
      "ScoreAttributes": {
        "ScoreConfidence": "HIGH"
      },
      "FeedbackToken": "AYADeCJbzjUjF_0N9tgD9KvVGPwAXwABABVhd3MtY3J5cHRvLXB1YmxpYy1rZXkAREF2MG1pWDB2VG9jbWRnZndSUXJqQ2lrL2hoRURzNHdXemJiOUkvWjJ0a0JmNjJSSVJZbklibTV0U2crekk3Zm94dz09AAEAB2F3cy1rbXMAS2Fybjphd3M6a21zOnVzLWVhc3QtMTo3OTQyODk5MjcwNzA6a2V5LzA4YjVkYTRmLWQyOWEtNDU3Mi04OTAwLTRkZjMzN2VjYzljYwC4AQIBAHj0zQzhkrLuQ7zD8HaKUpTKx0B1ZhTxova5poogpTSq9gFY_kCqy-4CRV-fBhH2hsWiAAAAfjB8BgkqhkiG9w0BBwagbzBtAgEAMGgGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMVyjzzVphIjHqA3Q5AgEQgDuqnglgXCO0uUGeSXdKd03Zj-2ogyJlKwjcl_Pr6MHI9jOug5mtuzCx8v0iJOAcigkoPT9qJ5P2M_eKwwIAAAAADAAAEAAAAAAAAAAAAAAAAABnxJg3Ru7KwgJ9BWT-NldI_____wAAAAEAAAAAAAAAAAAAAAEAAAF2RG3ZtGeV0rlFH_Ex1Iii1H66uwaihAiqCs7RZVsA7o_DXsduGPLQEpg6OvzkUH8xWu8OmfrLiNOH7tDDt_GBFRSVrsZOJdUAcUtICj1J2rrjPlulJNNhHz_jNgLg0OBKjqxSTfAaHh0f3d69Y0Td3iaRLNFtVyyC-A5TBY4SDWmi_G0TXsHGlzMWvSYVPVNbO-OApxBVxz3xTaJCjxfsoP_UoXh75ZQKt37jPpz3se9pf3aYh4qiBJ7kGhvHmunAM63cu02FuOLGd6ddF6AFuBcRqsq3sRNFzInmaqYJ8QIZlNANDiZZYgMyIm6aXIAMzOdmUhic84WuamtUzwTkL6DPbL8TC4jtuwhzFuVoiRlx33y9m73qFkXpltQgIlhDH1W6eRZHo2zFw7oN7EpDt2Ptw3A64G2pmemCVo4TTzI_EOcM27ZD3NWVSZSZKgfnszBX6GYYxaPGJwgtkrAEEiG5fQtgbCPWKaD58JrT8xPi-6kCKxs9gttff11hDpL0pZE8JaIdAGcwZQIwYYEIGuY6NroB8YvBGRueqEbx7DVQeBLwFeWCmHN8muQSzwiftrfGwgfXBHTyM-dtAjEA3LGtPAzOSIDSjNgybqMM6uQON3U8278vDMPwuk8K4aFpp6Gzd3pmhVOySUmqkEZ7.f18ade72-e569-4d65-9b88-55c8ff8817e2-fbef050a-ba5a-4e53-9f4f-20d84c4d9da7"
    },
    {
      "Id": "f18ade72-e569-4d65-9b88-55c8ff8817e2-2ba7a591-30d5-4d2d-8ec1-e0d0a0b4bbff",
      "Type": "DOCUMENT",
      "AdditionalAttributes": [],
      "DocumentId": "s3://cie-mi211pilotsearch-kendra/services/5328_service.html",
      "DocumentTitle": {
        "Text": "FOOD PANTRY-EAST LEONARD CHRISTIAN REFORMED CHURCH-5328",
        "Highlights": [
          {
            "BeginOffset": 0,
            "EndOffset": 4,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 5,
            "EndOffset": 11,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentExcerpt": {
        "Text": "...Food Pantries                             \n\tKent, 49503, Grand Rapids \n\t                                                                    \n\n\n                                            \nFOOD PANTRY\n                        \t Offers basic food items, paper products, some...",
        "Highlights": [
          {
            "BeginOffset": 3,
            "EndOffset": 7,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 8,
            "EndOffset": 16,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 60,
            "EndOffset": 65,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 66,
            "EndOffset": 72,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 191,
            "EndOffset": 195,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 196,
            "EndOffset": 202,
            "TopAnswer": false,
            "Type": "STANDARD"
          },
          {
            "BeginOffset": 242,
            "EndOffset": 246,
            "TopAnswer": false,
            "Type": "STANDARD"
          }
        ]
      },
      "DocumentURI": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/5328_service.html",
      "DocumentAttributes": [
        {
          "Key": "_data_source_id",
          "Value": {
            "StringValue": "3c563725-4a80-48c5-b497-6d0d45d30316"
          }
        },
        {
          "Key": "_source_uri",
          "Value": {
            "StringValue": "https://s3.us-east-1.amazonaws.com/cie-mi211pilotsearch-kendra/services/5328_service.html"
          }
        }
      ],
      "ScoreAttributes": {
        "ScoreConfidence": "HIGH"
      },
      "FeedbackToken": "AYADeCJbzjUjF_0N9tgD9KvVGPwAXwABABVhd3MtY3J5cHRvLXB1YmxpYy1rZXkAREF2MG1pWDB2VG9jbWRnZndSUXJqQ2lrL2hoRURzNHdXemJiOUkvWjJ0a0JmNjJSSVJZbklibTV0U2crekk3Zm94dz09AAEAB2F3cy1rbXMAS2Fybjphd3M6a21zOnVzLWVhc3QtMTo3OTQyODk5MjcwNzA6a2V5LzA4YjVkYTRmLWQyOWEtNDU3Mi04OTAwLTRkZjMzN2VjYzljYwC4AQIBAHj0zQzhkrLuQ7zD8HaKUpTKx0B1ZhTxova5poogpTSq9gFY_kCqy-4CRV-fBhH2hsWiAAAAfjB8BgkqhkiG9w0BBwagbzBtAgEAMGgGCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMVyjzzVphIjHqA3Q5AgEQgDuqnglgXCO0uUGeSXdKd03Zj-2ogyJlKwjcl_Pr6MHI9jOug5mtuzCx8v0iJOAcigkoPT9qJ5P2M_eKwwIAAAAADAAAEAAAAAAAAAAAAAAAAABnxJg3Ru7KwgJ9BWT-NldI_____wAAAAEAAAAAAAAAAAAAAAEAAAF2RG3ZtGeV0rlFH_Ex1Iii1H66uwaihAiqCs7RZVsA7o_DXsduGPLQEpg6OvzkUH8xWu8OmfrLiNOH7tDDt_GBFRSVrsZOJdUAcUtICj1J2rrjPlulJNNhHz_jNgLg0OBKjqxSTfAaHh0f3d69Y0Td3iaRLNFtVyyC-A5TBY4SDWmi_G0TXsHGlzMWvSYVPVNbO-OApxBVxz3xTaJCjxfsoP_UoXh75ZQKt37jPpz3se9pf3aYh4qiBJ7kGhvHmunAM63cu02FuOLGd6ddF6AFuBcRqsq3sRNFzInmaqYJ8QIZlNANDiZZYgMyIm6aXIAMzOdmUhic84WuamtUzwTkL6DPbL8TC4jtuwhzFuVoiRlx33y9m73qFkXpltQgIlhDH1W6eRZHo2zFw7oN7EpDt2Ptw3A64G2pmemCVo4TTzI_EOcM27ZD3NWVSZSZKgfnszBX6GYYxaPGJwgtkrAEEiG5fQtgbCPWKaD58JrT8xPi-6kCKxs9gttff11hDpL0pZE8JaIdAGcwZQIwYYEIGuY6NroB8YvBGRueqEbx7DVQeBLwFeWCmHN8muQSzwiftrfGwgfXBHTyM-dtAjEA3LGtPAzOSIDSjNgybqMM6uQON3U8278vDMPwuk8K4aFpp6Gzd3pmhVOySUmqkEZ7.f18ade72-e569-4d65-9b88-55c8ff8817e2-2ba7a591-30d5-4d2d-8ec1-e0d0a0b4bbff"
    }
  ],
  "FacetResults": [],
  "TotalNumberOfResults": 9145
};

const advSearchMockData = [
  {
    "id": 1,
    "organization_name": "Dabfeed",
    "service_name": "Rohan, Lang and Kris",
    "service_description": "Vestibulum ac est lacinia nisi venenatis tristique.",
    "taxonomy_name": "Duis mattis egestas metus.",
    "taxonomy_description": "Morbi odio odio, elementum eu, interdum eu, tincidunt in, leo.",
    "svc_desc_score": 2.59869,
    "svc_name_score": 19.88418,
    "org_name_score": 3.11522,
    "tax_name_score": 9.07978,
    "tax_desc_score": 14.7735,
    "distance_miles": 46.25,
    "calculated_score": 152.10411
  }, {
    "id": 2,
    "organization_name": "Muxo",
    "service_name": "Casper, Pouros and Goyette",
    "service_description": "Vivamus vestibulum sagittis sapien.",
    "taxonomy_name": "Vivamus metus arcu, adipiscing molestie.",
    "taxonomy_description": "Maecenas rhoncus aliquam lacus.",
    "svc_desc_score": 7.9184,
    "svc_name_score": 9.22651,
    "org_name_score": 19.03806,
    "tax_name_score": 18.32401,
    "tax_desc_score": 4.95028,
    "distance_miles": 11.641,
    "calculated_score": 216.73078
  }, {
    "id": 3,
    "organization_name": "Linktype",
    "service_name": "Schaden Group",
    "service_description": "Donec diam neque, vestibulum eget.",
    "taxonomy_name": "Nam congue, risus semper porta volutpat",
    "taxonomy_description": "Vestibulum ante ipsum primis in faucibus .",
    "svc_desc_score": 8.54096,
    "svc_name_score": 7.99117,
    "org_name_score": 2.53023,
    "tax_name_score": 0.59875,
    "tax_desc_score": 5.0036,
    "distance_miles": 27.756,
    "calculated_score": 96.23813
  }, {
    "id": 4,
    "organization_name": "Ooba",
    "service_name": "Yundt-D'Amore",
    "service_description": "Maecenas ut massa quis augue luctus tincidunt.",
    "taxonomy_name": "In hac habitasse platea dictumst.",
    "taxonomy_description": "Praesent blandit lacinia erat.",
    "svc_desc_score": 15.00525,
    "svc_name_score": 13.70085,
    "org_name_score": 22.5595,
    "tax_name_score": 13.88066,
    "tax_desc_score": 5.38583,
    "distance_miles": 39.854,
    "calculated_score": 221.74227
  }, {
    "id": 5,
    "organization_name": "Wordpedia",
    "service_name": "Rath, Farrell and Bogisich",
    "service_description": "Sed vel enim sit amet nunc viverra dapibus.",
    "taxonomy_name": "Sed vel enim sit amet nunc viverra dapibus.",
    "taxonomy_description": "Nulla neque libero, convallis eget.",
    "svc_desc_score": 15.79679,
    "svc_name_score": 17.68871,
    "org_name_score": 2.16475,
    "tax_name_score": 10.60903,
    "tax_desc_score": 13.02642,
    "distance_miles": 15.103,
    "calculated_score": 212.7541
  }, {
    "id": 6,
    "organization_name": "Bluejam",
    "service_name": "Willms-Morissette",
    "service_description": "Aenean auctor gravida sem.",
    "taxonomy_name": "Nulla justo.",
    "taxonomy_description": "Quisque porta volutpat erat.",
    "svc_desc_score": 20.376,
    "svc_name_score": 15.12121,
    "org_name_score": 8.28891,
    "tax_name_score": 3.25488,
    "tax_desc_score": 11.26902,
    "distance_miles": 40.679,
    "calculated_score": 184.25106
  }, {
    "id": 7,
    "organization_name": "Quatz",
    "service_name": "Murray-Boyle",
    "service_description": "Fusce congue, diam id ornare imperdiet.",
    "taxonomy_name": "Vivamus tortor.",
    "taxonomy_description": "Pellentesque at nulla.",
    "svc_desc_score": 19.33827,
    "svc_name_score": 9.06442,
    "org_name_score": 14.18781,
    "tax_name_score": 9.06447,
    "tax_desc_score": 2.80431,
    "distance_miles": 46.546,
    "calculated_score": 166.83184
  }, {
    "id": 8,
    "organization_name": "Zazio",
    "service_name": "Veum and Sons",
    "service_description": "Etiam pretium iaculis justo.",
    "taxonomy_name": "Sed accumsan felis.",
    "taxonomy_description": "In blandit ultrices enim.",
    "svc_desc_score": 18.92697,
    "svc_name_score": 18.97241,
    "org_name_score": 18.51732,
    "tax_name_score": 5.0263,
    "tax_desc_score": 14.9598,
    "distance_miles": 34.381,
    "calculated_score": 244.8274
  }, {
    "id": 9,
    "organization_name": "Gabcube",
    "service_name": "Lind, Padberg and Parisian",
    "service_description": "Maecenas tristique, est et tempus semper.",
    "taxonomy_name": "Cum sociis natoque penatibus et magnis dis parturient montes.",
    "taxonomy_description": "Donec semper sapien a libero.",
    "svc_desc_score": 9.47881,
    "svc_name_score": 19.24103,
    "org_name_score": 7.34138,
    "tax_name_score": 9.44957,
    "tax_desc_score": 1.74964,
    "distance_miles": 10.701,
    "calculated_score": 181.08029
  }, {
    "id": 10,
    "organization_name": "Jaxbean",
    "service_name": "Blanda, Cronin and Auer",
    "service_description": "Curabitur in libero ut massa volutpat convallis.",
    "taxonomy_name": "Nam tristique tortor eu pede.",
    "taxonomy_description": "Vestibulum ac est lacinia nisi venenatis tristique.",
    "svc_desc_score": 3.09139,
    "svc_name_score": 5.83068,
    "org_name_score": 5.6703,
    "tax_name_score": 20.66232,
    "tax_desc_score": 19.6549,
    "distance_miles": 48.99,
    "calculated_score": 165.73877
  }
]

const areaZipcodeListMockedData = [
  {
    "id": 1,
    "type": "zipcode",
    "name": "48001"
  },
  {
    "id": 4,
    "type": "zipcode",
    "name": "48002"
  },
  {
    "id": 5,
    "type": "zipcode",
    "name": "48003"
  },
  {
    "id": 6,
    "type": "zipcode",
    "name": "48004"
  },
  {
    "id": 7,
    "type": "zipcode",
    "name": "48005-Macomb"
  },
  {
    "id": 8,
    "type": "zipcode",
    "name": "48005-Saint Clair"
  },
  {
    "id": 9,
    "type": "zipcode",
    "name": "48006"
  },
  {
    "id": 10,
    "type": "zipcode",
    "name": "48007"
  },
  {
    "id": 11,
    "type": "zipcode",
    "name": "48009"
  },
  {
    "id": 12,
    "type": "zipcode",
    "name": "48012"
  },
  {
    "id": 13,
    "type": "zipcode",
    "name": "48014-Lapeer"
  },
  {
    "id": 14,
    "type": "zipcode",
    "name": "48014-Saint Clair"
  },
  {
    "id": 17,
    "type": "zipcode",
    "name": "48015"
  },
  {
    "id": 18,
    "type": "zipcode",
    "name": "48017"
  },
  {
    "id": 19,
    "type": "zipcode",
    "name": "48021"
  },
  {
    "id": 20,
    "type": "zipcode",
    "name": "48022"
  },
  {
    "id": 22,
    "type": "zipcode",
    "name": "48023"
  },
  {
    "id": 24,
    "type": "zipcode",
    "name": "48025"
  },
  {
    "id": 27,
    "type": "zipcode",
    "name": "48026"
  },
  {
    "id": 28,
    "type": "zipcode",
    "name": "48027"
  },
  {
    "id": 29,
    "type": "zipcode",
    "name": "48028"
  },
  {
    "id": 30,
    "type": "zipcode",
    "name": "48030"
  },
  {
    "id": 31,
    "type": "zipcode",
    "name": "48032-Saint Clair"
  },
  {
    "id": 32,
    "type": "zipcode",
    "name": "48032-Sanilac"
  },
  {
    "id": 33,
    "type": "zipcode",
    "name": "48033"
  },
  {
    "id": 34,
    "type": "zipcode",
    "name": "48034"
  },
  {
    "id": 35,
    "type": "zipcode",
    "name": "48035"
  },
  {
    "id": 36,
    "type": "zipcode",
    "name": "48036"
  },
  {
    "id": 37,
    "type": "zipcode",
    "name": "48037"
  },
  {
    "id": 38,
    "type": "zipcode",
    "name": "48038"
  },
  {
    "id": 39,
    "type": "zipcode",
    "name": "48039"
  },
  {
    "id": 40,
    "type": "zipcode",
    "name": "48040"
  },
  {
    "id": 41,
    "type": "zipcode",
    "name": "48041-Macomb"
  },
  {
    "id": 42,
    "type": "zipcode",
    "name": "48041-Saint Clair"
  },
  {
    "id": 43,
    "type": "zipcode",
    "name": "48042"
  },
  {
    "id": 44,
    "type": "zipcode",
    "name": "48043"
  },
  {
    "id": 45,
    "type": "zipcode",
    "name": "48044"
  },
  {
    "id": 46,
    "type": "zipcode",
    "name": "48045"
  },
  {
    "id": 48,
    "type": "zipcode",
    "name": "48046"
  }
]


module.exports = {
  areaZipcodeListMockedData,
  advSearchMockData,
  locationMockedData,
  serviceListMockedData,
  serviceDetailMockedData,
  mockServiceRec,
  mockSearchResponse
}